// Lesson 1 - Introduction to Statistics and Research
// Research methodology and statistical analysis

export const questions = {
  "1. Introduction to Research": [
    {
      id: 60001,
      question: "What does IMRaD stand for in research article formatting?",
      options: [
        "Introduction, Methods, Results, and Discussion",
        "Information, Materials, Research, and Data",
        "Initial, Methodology, Review, and Description",
        "Introduction, Methodology, Review, and Data",
      ],
      correct: "A"
    },
    {
      id: 60002,
      question: "What is the recommended length for a good research paper title?",
      options: [
        "5-7 words",
        "10-12 words",
        "15-20 words",
        "20-25 words",
      ],
      correct: "B"
    },
    {
      id: 60003,
      question: "Which of the following is NOT one of the three basic tips for writing a research title?",
      options: [
        "Keep it simple, attractive, and brief",
        "Use appropriate and descriptive words",
        "Include all abbreviations used in the study",
        "Avoid abbreviations and jargons",
      ],
      correct: "C"
    },
    {
      id: 60004,
      question: "Which title follows the best practices for research paper titles?",
      options: [
        "HAART is more functional on different stages of HIV life-cycle",
        "Highly active antiretroviral therapy is more functional on different stages of HIV life-cycle",
        "Effects of HIV therapy: a study",
        "HAART and HIV: research findings",
      ],
      correct: "B"
    },
    {
      id: 60005,
      question: "According to the material, what should be done first before composing the best title for a research paper?",
      options: [
        "Write the abstract",
        "Complete the results section",
        "Write down the hypothesis",
        "Finish the literature review",
      ],
      correct: "C"
    },
    {
      id: 60006,
      question: "Which title better demonstrates the use of appropriate and descriptive words?",
      options: [
        "Effects of trilafon on schizophrenia patients: study of a multicenter mixed group",
        "Psychosocial effects of trilafon on schizophrenia patients: a multicenter randomized controlled trial",
        "Trilafon study on patients",
        "Drug effects on mental health patients",
      ],
      correct: "B"
    },
    {
      id: 60007,
      question: "What is the primary purpose of an abstract in a research paper?",
      options: [
        "To provide detailed methodology",
        "To briefly explain what the researchers did and concluded",
        "To list all references used",
        "To acknowledge funding sources",
      ],
      correct: "B"
    },
    {
      id: 60008,
      question: "When should the abstract be written according to the material?",
      options: [
        "Before starting the research",
        "During data collection",
        "After finishing writing the paper",
        "Before writing the introduction",
      ],
      correct: "C"
    },
    {
      id: 60009,
      question: "What should NOT be contained in an abstract?",
      options: [
        "Major objectives and conclusions",
        "Key sentences from the Methods section",
        "New information not present in the paper",
        "Major results from the Results section",
      ],
      correct: "C"
    },
    {
      id: 60010,
      question: "Which of the following should be avoided in an abstract?",
      options: [
        "Background information",
        "Methods summary",
        "Undefined abbreviations or group names",
        "Key conclusions",
      ],
      correct: "C"
    },
    {
      id: 60011,
      question: "In scientific writing, abstracts are usually structured to describe which elements?",
      options: [
        "Title, authors, and funding",
        "Background, methods, results, and conclusions",
        "Only the hypothesis and results",
        "References and acknowledgments",
      ],
      correct: "B"
    },
    {
      id: 60012,
      question: "What does the introduction section of a research paper present?",
      options: [
        "Detailed statistical analysis",
        "The background of the problem and existing research on the subject",
        "Only the final conclusions",
        "Equipment specifications",
      ],
      correct: "B"
    },
    {
      id: 60013,
      question: "What does a hypothesis clarify in research?",
      options: [
        "The funding sources for the study",
        "The potential relationship between two or more variables related to the main research theme",
        "The timeline of the research project",
        "The names of all participants",
      ],
      correct: "B"
    },
    {
      id: 60014,
      question: "Regarding citations in the introduction, which statement is correct?",
      options: [
        "Only old articles should be cited",
        "Older articles might be listed, but most should be recent ones",
        "No citations are needed in the introduction",
        "Only articles from the same author should be cited",
      ],
      correct: "B"
    },
    {
      id: 60015,
      question: "Which of the following is a question that should be considered in the introduction?",
      options: [
        "How much did the research cost?",
        "What is the main problem?",
        "Who will publish the paper?",
        "When will the research end?",
      ],
      correct: "B"
    },
    {
      id: 60016,
      question: "What does the Materials and Methods section describe?",
      options: [
        "The conclusions of the study",
        "The techniques and materials used in a specific survey",
        "The background of the researchers",
        "Future research recommendations",
      ],
      correct: "B"
    },
    {
      id: 60017,
      question: "Why should research be replicable?",
      options: [
        "To increase publication chances",
        "So any other researchers can repeat the same experiment and reproduce the same results",
        "To reduce research costs",
        "To shorten the research timeline",
      ],
      correct: "B"
    },
    {
      id: 60018,
      question: "What should be clarified in the Materials and Methods section?",
      options: [
        "Personal opinions of the researchers",
        "Origins of materials and samples, equipment make and model, quantities and duration",
        "Funding agency preferences",
        "Publication goals",
      ],
      correct: "B"
    },
    {
      id: 60019,
      question: "What are the three main approaches to research methods?",
      options: [
        "Primary, secondary, and tertiary methods",
        "Qualitative, quantitative, and mixed methods",
        "Simple, complex, and hybrid methods",
        "Basic, applied, and theoretical methods",
      ],
      correct: "B"
    },
    {
      id: 60020,
      question: "Which statement best describes qualitative research?",
      options: [
        "An objective approach based on number analyses",
        "A comprehensive approach based on observation analyses",
        "A method that only uses statistical tools",
        "A technique that focuses solely on numerical data",
      ],
      correct: "B"
    },
    {
      id: 60021,
      question: "Which statement best describes quantitative research?",
      options: [
        "A comprehensive approach based on observation analyses",
        "An objective approach based on number analyses",
        "A method that avoids all numerical data",
        "A technique that only uses interviews",
      ],
      correct: "B"
    },
    {
      id: 60022,
      question: "What is the mixed method in research?",
      options: [
        "Using only qualitative methods",
        "Using only quantitative methods",
        "A combination of qualitative and quantitative methods",
        "Avoiding both qualitative and quantitative approaches",
      ],
      correct: "C"
    },
    {
      id: 60023,
      question: "According to the material, which research method is described as more practical?",
      options: [
        "Qualitative method",
        "Quantitative method",
        "Mixed method",
        "Theoretical method",
      ],
      correct: "C"
    },
    {
      id: 60024,
      question: "What is data falsification?",
      options: [
        "Making up data without any basis and facts",
        "Changing the results obtained from experiments so the research question will be answered favorably",
        "Copying text from other sources without citation",
        "Refusing to share research data",
      ],
      correct: "B"
    },
    {
      id: 60025,
      question: "What is data fabrication?",
      options: [
        "Changing experimental results to support the hypothesis",
        "Making up something without any basis and facts",
        "Accidentally using too much original text from sources",
        "Hiding negative results from a study",
      ],
      correct: "A"
    },
    {
      id: 60026,
      question: "What is unintentional plagiarism?",
      options: [
        "Deliberately presenting others\' ideas as your own",
        "Using too much original text from referenced works while citing them extensively",
        "Making up data without experiments",
        "Changing research results",
      ],
      correct: "B"
    },
    {
      id: 60027,
      question: "What is intentional plagiarism?",
      options: [
        "Accidentally using similar wording to other papers",
        "Presenting results or ideas from other published articles as one\'s own without citing the real authors",
        "Making typographical errors in citations",
        "Using outdated references",
      ],
      correct: "B"
    },
    {
      id: 60028,
      question: "What is a conflict of interest in research?",
      options: [
        "Disagreement between co-authors",
        "When a funding entity forces researchers not to report negative outcomes",
        "Competition between research teams",
        "Disputes over publication rights",
      ],
      correct: "B"
    },
    {
      id: 60029,
      question: "In the conflict of interest example provided, what should the research team do when a pharmaceutical company wants them to suppress negative results?",
      options: [
        "Accept the manufacturer\'s request",
        "Only report positive findings",
        "Not accept what the manufacturer requests",
        "Withdraw from the study",
      ],
      correct: "C"
    },
    {
      id: 60030,
      question: "How many unethical practices in research are identified in the material?",
      options: [
        "3",
        "4",
        "5",
        "6",
      ],
      correct: "C"
    },
    {
      id: 60031,
      question: "Which of the following is NOT listed as one of the five unethical practices in research?",
      options: [
        "Data falsification",
        "Data fabrication",
        "Data sharing",
        "Conflict of interest",
      ],
      correct: "C"
    },
    {
      id: 60032,
      question: "What is required for all research according to the ethics section?",
      options: [
        "Publication in peer-reviewed journals",
        "Ethical review and approval",
        "Minimum of three authors",
        "International collaboration",
      ],
      correct: "B"
    },
    {
      id: 60033,
      question: "Which is NOT mentioned as an important ethics issue in medical and clinical research?",
      options: [
        "Respect the human dignity",
        "Obtaining informed consent",
        "Maximum profit generation",
        "Privacy and confidentiality of participants",
      ],
      correct: "C"
    },
    {
      id: 60034,
      question: "What does \"coercion of participants\" relate to in research ethics?",
      options: [
        "Mandatory data sharing",
        "Voluntary participation",
        "Required publication",
        "Forced authorship",
      ],
      correct: "B"
    },
    {
      id: 60035,
      question: "Which component is NOT listed as part of a research article\'s basic structure?",
      options: [
        "Abstract",
        "Discussion",
        "Budget breakdown",
        "References",
      ],
      correct: "C"
    },
    {
      id: 60036,
      question: "What is the purpose of the Results section in a research paper?",
      options: [
        "To describe the background of the problem",
        "To present the findings of the study",
        "To explain the methodology used",
        "To list all references",
      ],
      correct: "B"
    },
    {
      id: 60037,
      question: "What comes after the Discussion section in the IMRaD format?",
      options: [
        "Introduction",
        "Methods",
        "Conclusion",
        "Abstract",
      ],
      correct: "C"
    },
    {
      id: 60038,
      question: "Which section of a research paper contains keywords?",
      options: [
        "Methods",
        "Abstract",
        "Results",
        "References",
      ],
      correct: "B"
    },
    {
      id: 60039,
      question: "What should the title of a research paper contain according to the material?",
      options: [
        "The names of all researchers",
        "Key words used in the manuscript that define the nature of the study",
        "The journal name",
        "The date of submission",
      ],
      correct: "B"
    },
    {
      id: 60040,
      question: "Which title demonstrates avoiding unnecessary words for better brevity?",
      options: [
        "Imipenem has an effect of inhibiting cell wall synthesis in gram-positive and gram-negative bacteria",
        "Imipenem inhibits cell wall synthesis in gram-positive and gram-negative bacteria",
        "A study on Imipenem and its various effects",
        "Research about Imipenem effects on bacteria",
      ],
      correct: "B"
    },
    {
      id: 60041,
      question: "What happens if your abstract is not attractive and does not make a good first impression?",
      options: [
        "The paper will automatically be accepted",
        "There\'s a chance of rejection at the outset",
        "The paper will be published faster",
        "More reviewers will be assigned",
      ],
      correct: "B"
    },
    {
      id: 60042,
      question: "According to the material, the abstract will often be the first and possibly only thing readers access through what?",
      options: [
        "Library catalogs",
        "Electronic searches",
        "Book reviews",
        "Conference proceedings",
      ],
      correct: "B"
    },
    {
      id: 60043,
      question: "What should be selected from the Introduction and Conclusion sections when writing an abstract?",
      options: [
        "All sentences",
        "Major objectives/hypotheses and conclusions",
        "Only the first paragraph",
        "Statistical data only",
      ],
      correct: "B"
    },
    {
      id: 60044,
      question: "What should be identified from the Results section when writing an abstract?",
      options: [
        "All tables and figures",
        "The major results",
        "Only negative findings",
        "Statistical methods used",
      ],
      correct: "B"
    },
    {
      id: 60045,
      question: "In what sequence should the abstract content be arranged?",
      options: [
        "Conclusions, Methods, Results, Introduction",
        "Results, Methods, Introduction, Conclusions",
        "Introduction (Background), Methods, Results, and Conclusions",
        "Methods, Introduction, Results, Conclusions",
      ],
      correct: "C"
    },
    {
      id: 60046,
      question: "What should be checked before finalizing an abstract?",
      options: [
        "If it matches other published abstracts",
        "If it meets the guidelines of the target journal",
        "If it includes all author names",
        "If it has been peer-reviewed",
      ],
      correct: "B"
    },
    {
      id: 60047,
      question: "What are the key ideas examined in the introductory section called?",
      options: [
        "Variables",
        "Concepts",
        "Hypotheses",
        "Objectives",
      ],
      correct: "B"
    },
    {
      id: 60048,
      question: "Why is citing papers written by experts important in the introduction?",
      options: [
        "To increase word count",
        "To demonstrate knowledge of the field and support claims",
        "To fill space",
        "To avoid writing original content",
      ],
      correct: "B"
    },
    {
      id: 60049,
      question: "Which section immediately follows the Introduction in the IMRaD format?",
      options: [
        "Results",
        "Discussion",
        "Materials and Methods",
        "Conclusion",
      ],
      correct: "C"
    },
    {
      id: 60050,
      question: "What makes the mixed method approach valuable in research?",
      options: [
        "It is the least expensive method",
        "It combines strengths of both qualitative and quantitative approaches",
        "It requires fewer participants",
        "It takes less time to complete",
      ],
      correct: "B"
    },
    {
      id: 60051,
      question: "According to research ethics, what must be obtained from participants?",
      options: [
        "Payment",
        "Informed consent",
        "Educational credentials",
        "Professional references",
      ],
      correct: "B"
    },
    {
      id: 60052,
      question: "What principle ensures that research participants are treated fairly?",
      options: [
        "Data fabrication protocols",
        "Equal treatment of participants",
        "Conflict of interest policies",
        "Publication requirements",
      ],
      correct: "B"
    },
    {
      id: 60053,
      question: "Who is the author of the source textbook referenced in the material?",
      options: [
        "Kamyar Motavaze only",
        "Davies B and Logan J",
        "Oxford College",
        "Elsevier Inc.",
      ],
      correct: "B"
    },
    {
      id: 60054,
      question: "What is the title of the reference textbook mentioned?",
      options: [
        "Introduction to Research Methods",
        "Reading research: A user-friendly guide for health professionals",
        "Research Ethics and Practice",
        "Scientific Writing Fundamentals",
      ],
      correct: "B"
    },
    {
      id: 60055,
      question: "What edition of the reference textbook is cited?",
      options: [
        "5th edition",
        "6th edition",
        "7th edition",
        "8th edition",
      ],
      correct: "C"
    },
    {
      id: 60056,
      question: "In what year was the reference textbook published?",
      options: [
        "2019",
        "2020",
        "2021",
        "2022",
      ],
      correct: "C"
    },
    {
      id: 60057,
      question: "What institution is associated with the course material?",
      options: [
        "Harvard University",
        "Oxford College",
        "Cambridge University",
        "Stanford University",
      ],
      correct: "B"
    },
    {
      id: 60058,
      question: "What is one key term listed in the material related to research article structure?",
      options: [
        "Bibliography",
        "IMRaD format",
        "Appendix",
        "Glossary",
      ],
      correct: "B"
    },
    {
      id: 60059,
      question: "Which of the following best describes why editorial restrictions sometimes limit ethics details?",
      options: [
        "Ethics are not important in research",
        "Space constraints may exclude thorough ethics discussion, but it remains important",
        "Ethics should never be discussed in papers",
        "Only clinical research requires ethics",
      ],
      correct: "B"
    },
    {
      id: 60060,
      question: "What should a well-performed research allow other researchers to do?",
      options: [
        "Modify the original conclusions",
        "Repeat the experiment and reproduce the same results",
        "Change the methodology",
        "Rewrite the introduction",
      ],
      correct: "B"
    },
    {
      id: 60061,
      question: "Which key term relates to the practice of making up research data?",
      options: [
        "Data falsification",
        "Data fabrication",
        "Intentional plagiarism",
        "Unintentional plagiarism",
      ],
      correct: "B"
    },
    {
      id: 60062,
      question: "What type of approach does qualitative research take?",
      options: [
        "Numerical analysis",
        "Observation analysis",
        "Statistical modeling",
        "Mathematical computation",
      ],
      correct: "B"
    },
    {
      id: 60063,
      question: "What type of approach does quantitative research take?",
      options: [
        "Observational analysis",
        "Interview-based analysis",
        "Number-based objective analysis",
        "Theoretical analysis",
      ],
      correct: "C"
    },
    {
      id: 60064,
      question: "Which component typically appears at the end of a research article?",
      options: [
        "Abstract",
        "Introduction",
        "References",
        "Title",
      ],
      correct: "C"
    },
    {
      id: 60065,
      question: "What may appear alongside or within the Acknowledgment section?",
      options: [
        "Abstract",
        "Authors Contributions",
        "Keywords",
        "Hypothesis",
      ],
      correct: "B"
    },
    {
      id: 60066,
      question: "According to the material, what do most journals expect regarding article format?",
      options: [
        "Custom formats",
        "Traditional IMRaD format",
        "No specific format",
        "Only digital formats",
      ],
      correct: "B"
    },
  ],
  "2. Qualitative Research": [
    {
      id: 60100,
      question: "What is qualitative research primarily based on?",
      options: [
        "Statistical analyses",
        "Observation analyses",
        "Mathematical calculations",
        "Numerical data",
      ],
      correct: "B"
    },
    {
      id: 60101,
      question: "What is the main goal of qualitative research?",
      options: [
        "To calculate statistical significance",
        "To measure numerical outcomes",
        "To study people\'s perceptions and experiences",
        "To test mathematical formulas",
      ],
      correct: "C"
    },
    {
      id: 60102,
      question: "Qualitative research is basically what type of research?",
      options: [
        "Confirmatory research",
        "Experimental research",
        "Exploratory research",
        "Correlational research",
      ],
      correct: "C"
    },
    {
      id: 60103,
      question: "What does exploratory research help to develop?",
      options: [
        "Only final conclusions",
        "Ideas or hypotheses for potential quantitative research",
        "Statistical models",
        "Mathematical equations",
      ],
      correct: "B"
    },
    {
      id: 60104,
      question: "How many characteristics of qualitative research are identified in the material?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six",
      ],
      correct: "C"
    },
    {
      id: 60105,
      question: "Qualitative research design is generally based on which perspective?",
      options: [
        "Positivism",
        "Constructivism",
        "Reductionism",
        "Empiricism",
      ],
      correct: "B"
    },
    {
      id: 60106,
      question: "In qualitative research, how small can sample sizes be?",
      options: [
        "Minimum of ten",
        "Minimum of fifty",
        "As small as one",
        "Minimum of one hundred",
      ],
      correct: "C"
    },
    {
      id: 60107,
      question: "Which of the following is NOT a method of data collection in qualitative research?",
      options: [
        "Interview",
        "Observation",
        "Statistical testing",
        "Archival (content) data",
      ],
      correct: "C"
    },
    {
      id: 60108,
      question: "What is interpretation in qualitative research based on?",
      options: [
        "Only numerical data",
        "Only researcher perspective",
        "A combination of researcher perspective and data collected",
        "Only statistical analysis",
      ],
      correct: "C"
    },
    {
      id: 60109,
      question: "How do research problems become research questions in qualitative design?",
      options: [
        "Through statistical analysis",
        "Based on prior research experience",
        "Through random selection",
        "Based on numerical calculations",
      ],
      correct: "B"
    },
    {
      id: 60110,
      question: "What does phenomenology research focus on?",
      options: [
        "Cultural groups",
        "Experiences concerning phenomena",
        "Historical patterns",
        "Statistical trends",
      ],
      correct: "A"
    },
    {
      id: 60111,
      question: "What are the two main approaches in phenomenology research?",
      options: [
        "Qualitative and quantitative",
        "Descriptive and interpretive",
        "Primary and secondary",
        "Active and passive",
      ],
      correct: "B"
    },
    {
      id: 60112,
      question: "What does the descriptive approach in phenomenology explain?",
      options: [
        "The researcher\'s personal opinions",
        "The experience as alleged by the study participants",
        "Statistical findings",
        "Historical trends",
      ],
      correct: "B"
    },
    {
      id: 60113,
      question: "What does the interpretive approach in phenomenology involve?",
      options: [
        "Statistical analysis by computers",
        "An interpretation of the experience by the researchers",
        "Participant self-analysis",
        "Numerical data processing",
      ],
      correct: "B"
    },
    {
      id: 60114,
      question: "What does grounded theory do?",
      options: [
        "Tests existing theories",
        "Theorizes what is in the data",
        "Confirms prior hypotheses",
        "Rejects all data",
      ],
      correct: "B"
    },
    {
      id: 60115,
      question: "How are data analyzed in grounded theory?",
      options: [
        "Through statistical software",
        "By random sampling",
        "By constant comparison of new and old data",
        "Through mathematical formulas",
      ],
      correct: "C"
    },
    {
      id: 60116,
      question: "What does ethnography research try to understand?",
      options: [
        "Individual experiences",
        "The world view of a cultural group",
        "Statistical patterns",
        "Mathematical relationships",
      ],
      correct: "B"
    },
    {
      id: 60117,
      question: "What does narrative research assume about individuals?",
      options: [
        "They prefer quantitative data",
        "They organize their experience into stories",
        "They cannot express their experiences",
        "They only communicate through numbers",
      ],
      correct: "B"
    },
    {
      id: 60118,
      question: "What does participatory action research require?",
      options: [
        "No participant involvement",
        "Full collaboration between researchers and participants",
        "Only researcher input",
        "Statistical expertise",
      ],
      correct: "B"
    },
    {
      id: 60119,
      question: "What is a case study?",
      options: [
        "A broad survey of many situations",
        "A profound study of a specific situation or event",
        "A statistical analysis of large datasets",
        "A mathematical model",
      ],
      correct: "B"
    },
    {
      id: 60120,
      question: "In a case study, what might \"the case\" refer to?",
      options: [
        "Only large populations",
        "A specific person, group, or bigger community",
        "Only statistical data",
        "Only historical events",
      ],
      correct: "B"
    },
    {
      id: 60121,
      question: "What does historical research investigate?",
      options: [
        "Future predictions",
        "Patterns and trends of past happenings and comparison to present ones",
        "Only current events",
        "Statistical forecasts",
      ],
      correct: "B"
    },
    {
      id: 60122,
      question: "How many common qualitative designs are discussed in the material?",
      options: [
        "Five",
        "Six",
        "Seven",
        "Eight",
      ],
      correct: "C"
    },
    {
      id: 60123,
      question: "What does trustworthiness represent in qualitative research?",
      options: [
        "The cost of the research",
        "Different steps to ensure high standard and validity of results",
        "The number of participants",
        "The length of the study",
      ],
      correct: "B"
    },
    {
      id: 60124,
      question: "How many aspects of trustworthiness are identified?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 60125,
      question: "What does credibility refer to in trustworthiness?",
      options: [
        "The cost of research",
        "The reality of the findings",
        "The number of researchers",
        "The length of the study",
      ],
      correct: "B"
    },
    {
      id: 60126,
      question: "What does dependability refer to in trustworthiness?",
      options: [
        "The funding source",
        "The researcher\'s qualifications",
        "Consistency of data over time",
        "The publication venue",
      ],
      correct: "C"
    },
    {
      id: 60127,
      question: "What does confirmability refer to in trustworthiness?",
      options: [
        "Participant satisfaction",
        "Establishment of the certainty",
        "Research budget",
        "Timeline adherence",
      ],
      correct: "B"
    },
    {
      id: 60128,
      question: "What does transferability refer to in trustworthiness?",
      options: [
        "Data storage methods",
        "Research funding",
        "Publication process",
        "Applicability to a similar group",
      ],
      correct: "D"
    },
    {
      id: 60129,
      question: "What does the Sample and Setting section describe?",
      options: [
        "Statistical methods",
        "The details of participants",
        "Mathematical formulas",
        "Computer software used",
      ],
      correct: "B"
    },
    {
      id: 60130,
      question: "How many key concepts should be explained by qualitative design methods regarding sample and setting?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six",
      ],
      correct: "C"
    },
    {
      id: 60131,
      question: "Which is NOT one of the five key concepts in sample and setting?",
      options: [
        "Characteristics of the participants",
        "Statistical significance level",
        "Procedures for participants selection",
        "Location (place setting) of the collected data",
      ],
      correct: "B"
    },
    {
      id: 60132,
      question: "What is the natural setting where qualitative research is usually performed called?",
      options: [
        "The laboratory",
        "The clinic",
        "The field",
        "The office",
      ],
      correct: "C"
    },
    {
      id: 60133,
      question: "What type of samples are qualitative samples?",
      options: [
        "Random samples",
        "Purposive samples",
        "Stratified samples",
        "Cluster samples",
      ],
      correct: "B"
    },
    {
      id: 60134,
      question: "Why must qualitative samples be purposive?",
      options: [
        "To reduce costs",
        "To save time",
        "Because they must provide the best information",
        "To simplify analysis",
      ],
      correct: "C"
    },
    {
      id: 60135,
      question: "Why can sample sizes in qualitative research be as small as one?",
      options: [
        "Because funding is limited",
        "Because numerical and statistical analyses are not necessary",
        "Because time is limited",
        "Because participants are hard to find",
      ],
      correct: "B"
    },
    {
      id: 60136,
      question: "What might a case study involve according to the material?",
      options: [
        "Only large populations",
        "A single person, group, or organization",
        "Only multiple groups",
        "Only organizations",
      ],
      correct: "B"
    },
    {
      id: 60137,
      question: "What does the Data Collection section explain?",
      options: [
        "Statistical formulas",
        "The specific method(s) to obtain the information",
        "Mathematical calculations",
        "Computer programming",
      ],
      correct: "B"
    },
    {
      id: 60138,
      question: "How many important concepts must be considered in the Data Collection section?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60139,
      question: "Which is one of the two important concepts in Data Collection?",
      options: [
        "How much did the research cost?",
        "What data were collected?",
        "Who funded the research?",
        "When was the research published?",
      ],
      correct: "B"
    },
    {
      id: 60140,
      question: "From how many sources might qualitative data be gathered?",
      options: [
        "Only one source",
        "Only multiple sources",
        "One source or different sources",
        "At least ten sources",
      ],
      correct: "C"
    },
    {
      id: 60141,
      question: "In qualitative research, who has a central role in both data collection and data analysis?",
      options: [
        "The participants",
        "The funding agency",
        "The researcher",
        "The publisher",
      ],
      correct: "C"
    },
    {
      id: 60142,
      question: "What does the Data Analysis and Results section describe?",
      options: [
        "Only the budget",
        "The analyses procedures as well as significant findings",
        "Only the timeline",
        "Only the participants",
      ],
      correct: "B"
    },
    {
      id: 60143,
      question: "Which is NOT a key issue to be clarified in the Data Analysis and Results section?",
      options: [
        "Procedures for data analysis",
        "Main research findings",
        "Funding sources",
        "Complete explanation of the results",
      ],
      correct: "C"
    },
    {
      id: 60144,
      question: "What tools can be used for complete explanation of results?",
      options: [
        "Only text descriptions",
        "Charts, figures, tables, etc.",
        "Only verbal presentations",
        "Only mathematical equations",
      ],
      correct: "B"
    },
    {
      id: 60145,
      question: "What sections might be combined as a single section?",
      options: [
        "Introduction and methods",
        "Results and discussion",
        "Abstract and conclusion",
        "Title and references",
      ],
      correct: "B"
    },
    {
      id: 60146,
      question: "Which key term relates to the consistency of data over time?",
      options: [
        "Credibility",
        "Confirmability",
        "Dependability",
        "Transferability",
      ],
      correct: "C"
    },
    {
      id: 60147,
      question: "Which key term relates to the reality of findings?",
      options: [
        "Dependability",
        "Credibility",
        "Transferability",
        "Confirmability",
      ],
      correct: "B"
    },
    {
      id: 60148,
      question: "Which key term relates to applicability to similar groups?",
      options: [
        "Credibility",
        "Dependability",
        "Confirmability",
        "Transferability",
      ],
      correct: "D"
    },
    {
      id: 60149,
      question: "Which key term relates to establishment of certainty?",
      options: [
        "Transferability",
        "Credibility",
        "Confirmability",
        "Dependability",
      ],
      correct: "C"
    },
    {
      id: 60150,
      question: "What type of research requires full collaboration between researchers and participants?",
      options: [
        "Historical research",
        "Case study",
        "Participatory action research",
        "Ethnography research",
      ],
      correct: "C"
    },
    {
      id: 60151,
      question: "What does qualitative research help to gain understanding of?",
      options: [
        "Only numerical data",
        "Underlying reasons",
        "Only statistical patterns",
        "Only mathematical relationships",
      ],
      correct: "B"
    },
    {
      id: 60152,
      question: "What are qualitative designs in relation to?",
      options: [
        "Statistical significance",
        "The meanings of a critical issue",
        "Numerical calculations",
        "Mathematical formulas",
      ],
      correct: "B"
    },
    {
      id: 60153,
      question: "What does exploratory research provide insights into?",
      options: [
        "Only final conclusions",
        "The problem",
        "Only statistical data",
        "Only mathematical models",
      ],
      correct: "B"
    },
    {
      id: 60154,
      question: "Which qualitative design investigates patterns and trends of past happenings?",
      options: [
        "Phenomenology research",
        "Grounded theory",
        "Ethnography research",
        "Historical research",
      ],
      correct: "D"
    },
    {
      id: 60155,
      question: "Which qualitative design assumes individuals organize experience into stories?",
      options: [
        "Narrative research",
        "Case study",
        "Grounded theory",
        "Phenomenology research",
      ],
      correct: "A"
    },
    {
      id: 60156,
      question: "What is the location of collected data also known as?",
      options: [
        "Laboratory setting",
        "Place setting",
        "Clinical setting",
        "Office setting",
      ],
      correct: "B"
    },
    {
      id: 60157,
      question: "Which of the following is a key concept in sample and setting?",
      options: [
        "Statistical power",
        "Similarity to previous experiments",
        "p-value calculation",
        "Hypothesis testing",
      ],
      correct: "B"
    },
    {
      id: 60158,
      question: "What perspective is qualitative research design generally based on?",
      options: [
        "Objectivism",
        "Rationalism",
        "Constructivism",
        "Determinism",
      ],
      correct: "C"
    },
    {
      id: 60159,
      question: "Who is the author of the reference textbook cited in this material?",
      options: [
        "Kamyar Motavaze",
        "Davies B and Logan J",
        "Oxford College",
        "Elsevier Inc.",
      ],
      correct: "B"
    },
    {
      id: 60160,
      question: "What institution is associated with this course material?",
      options: [
        "Cambridge University",
        "Harvard University",
        "Oxford College",
        "Stanford University",
      ],
      correct: "C"
    },
    {
      id: 60161,
      question: "What is the title of the reference textbook?",
      options: [
        "Qualitative Research Methods",
        "Reading research: A user-friendly guide for health professionals",
        "Introduction to Research Design",
        "Research Methodology Fundamentals",
      ],
      correct: "B"
    },
    {
      id: 60162,
      question: "What edition of the reference textbook is cited?",
      options: [
        "5th edition",
        "6th edition",
        "7th edition",
        "8th edition",
      ],
      correct: "C"
    },
    {
      id: 60163,
      question: "In what year was the reference textbook published?",
      options: [
        "2019",
        "2020",
        "2021",
        "2022",
      ],
      correct: "C"
    },
    {
      id: 60164,
      question: "What is the basis of sample size one of the key concepts to explain?",
      options: [
        "In data analysis",
        "In sample and setting",
        "In results section",
        "In abstract section",
      ],
      correct: "B"
    },
    {
      id: 60165,
      question: "Which research type tries to understand the world view of a cultural group?",
      options: [
        "Phenomenology research",
        "Narrative research",
        "Ethnography research",
        "Case study",
      ],
      correct: "C"
    },
  ],
  "3. Quantitative Research (Part 1)": [
    {
      id: 60200,
      question: "What is the final goal of quantitative research?",
      options: [
        "To study people\'s perceptions",
        "To describe and compare different variables and characteristics",
        "To conduct interviews",
        "To observe behaviors",
      ],
      correct: "B"
    },
    {
      id: 60201,
      question: "What type of techniques are of great importance in quantitative research?",
      options: [
        "Observational techniques",
        "Interview techniques",
        "Statistical and mathematical techniques",
        "Narrative techniques",
      ],
      correct: "C"
    },
    {
      id: 60202,
      question: "What are quantitative variables?",
      options: [
        "Variables based on observations",
        "Numerical variables that represent a measurable quantity",
        "Variables based on interviews",
        "Variables based on stories",
      ],
      correct: "B"
    },
    {
      id: 60203,
      question: "Which of the following is an example of a quantitative variable?",
      options: [
        "Personal opinion",
        "Life experience",
        "Infection rate",
        "Cultural belief",
      ],
      correct: "C"
    },
    {
      id: 60204,
      question: "In the deductive approach, what does the researcher know?",
      options: [
        "Nothing about the topic",
        "Facts and ideas based on previous experiments",
        "Only qualitative data",
        "Only participant opinions",
      ],
      correct: "B"
    },
    {
      id: 60205,
      question: "When is the exploratory approach used in quantitative research?",
      options: [
        "When there is significant prior research",
        "When the researcher has little information due to lack of previously performed experiments",
        "When statistical analysis is complete",
        "When results are already known",
      ],
      correct: "B"
    },
    {
      id: 60206,
      question: "What type of approaches are deductive approaches?",
      options: [
        "Exploratory",
        "Observational",
        "Comparative",
        "Narrative",
      ],
      correct: "C"
    },
    {
      id: 60207,
      question: "How many types of quantitative designs are identified in the material?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 60208,
      question: "Which of the following is NOT a type of quantitative design?",
      options: [
        "Experimental",
        "Quasi-experimental",
        "Non-experimental",
        "Phenomenological",
      ],
      correct: "D"
    },
    {
      id: 60209,
      question: "What are the three special features of experimental designs?",
      options: [
        "Surveys, interviews, and observations",
        "Randomization, control groups, and intervention",
        "Cases, controls, and correlations",
        "Pretest, posttest, and time series",
      ],
      correct: "B"
    },
    {
      id: 60210,
      question: "What is an intervention in experimental design?",
      options: [
        "A type of survey",
        "A special treatment or procedure",
        "A statistical calculation",
        "A data collection method",
      ],
      correct: "B"
    },
    {
      id: 60211,
      question: "What does randomization avoid in clinical trials?",
      options: [
        "Data collection",
        "Allocation bias",
        "Statistical analysis",
        "Patient participation",
      ],
      correct: "B"
    },
    {
      id: 60212,
      question: "How are patients typically randomized in clinical trials?",
      options: [
        "By researcher preference",
        "By patient choice",
        "By a computer-based program",
        "By alphabetical order",
      ],
      correct: "C"
    },
    {
      id: 60213,
      question: "How many ways can randomization be refined?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 60214,
      question: "What is stratified randomization?",
      options: [
        "Random selection without any criteria",
        "Classification of strata based on predictive variables with randomization within each stratum",
        "Selection of entire groups",
        "Sequential assignment of patients",
      ],
      correct: "B"
    },
    {
      id: 60215,
      question: "In stratified randomization, how is the randomization scheme carried out?",
      options: [
        "Only once for all participants",
        "Separately and equally within each stratum",
        "Based on patient preference",
        "By the researcher\'s choice",
      ],
      correct: "B"
    },
    {
      id: 60216,
      question: "What does constrained (blocked) randomization constitute?",
      options: [
        "Unequal treatment groups",
        "Roughly equal-sized treatment groups",
        "Only one treatment group",
        "No treatment groups",
      ],
      correct: "B"
    },
    {
      id: 60217,
      question: "How is blocked randomization performed?",
      options: [
        "By choosing large block sizes",
        "By choosing small block sizes with equal allocation to treatments in each block",
        "By random selection without blocks",
        "By patient self-selection",
      ],
      correct: "B"
    },
    {
      id: 60218,
      question: "When is cluster randomization used?",
      options: [
        "When individuals should be randomized separately",
        "When it is not rational to randomize participants individually",
        "When only one participant is needed",
        "When no groups exist",
      ],
      correct: "B"
    },
    {
      id: 60219,
      question: "Which is an example of when cluster randomization would be appropriate?",
      options: [
        "Individual drug testing",
        "Fluoride in drinking water",
        "Personal diet study",
        "Individual exercise program",
      ],
      correct: "B"
    },
    {
      id: 60220,
      question: "What do quasi-experimental designs lack?",
      options: [
        "Participants",
        "Data collection methods",
        "One or more essential characteristics of experimental designs",
        "Research questions",
      ],
      correct: "C"
    },
    {
      id: 60221,
      question: "How many types of quasi-experimental designs are mentioned?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60222,
      question: "What is a pretest-posttest design?",
      options: [
        "A study with multiple groups",
        "A study where participants are studied before and after experiment without random assignment",
        "A study with only random assignment",
        "A retrospective study",
      ],
      correct: "B"
    },
    {
      id: 60223,
      question: "What is an example of a pretest-posttest design mentioned in the material?",
      options: [
        "Weight loss study",
        "Botox injection",
        "Fluoride study",
        "Drug trial",
      ],
      correct: "B"
    },
    {
      id: 60224,
      question: "What is a time series design?",
      options: [
        "A study at one point in time",
        "A study where participants are studied before and after experiment at multiple points of time",
        "A study without any time measurement",
        "A retrospective study only",
      ],
      correct: "B"
    },
    {
      id: 60225,
      question: "What is an example of a time series design mentioned in the material?",
      options: [
        "Botox injection",
        "Fluoride study",
        "Weight loss",
        "Drug trial",
      ],
      correct: "C"
    },
    {
      id: 60226,
      question: "How many non-experimental designs are identified?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 60227,
      question: "Which is NOT a non-experimental design?",
      options: [
        "Cohort study",
        "Case-control study",
        "Stratified randomization",
        "Surveys",
      ],
      correct: "C"
    },
    {
      id: 60228,
      question: "How is a cohort study typically designed?",
      options: [
        "Retrospectively only",
        "Prospectively (but not always)",
        "Without following individuals",
        "Without investigating relationships",
      ],
      correct: "B"
    },
    {
      id: 60229,
      question: "What does a cohort study investigate?",
      options: [
        "Only patient preferences",
        "The relationship between an aetiological factor and incidence of disease",
        "Only qualitative data",
        "Only survey responses",
      ],
      correct: "B"
    },
    {
      id: 60230,
      question: "What is a factor called if it affects the incidence of disease?",
      options: [
        "Control factor",
        "Outcome factor",
        "Risk factor",
        "Study factor",
      ],
      correct: "C"
    },
    {
      id: 60231,
      question: "How are individuals followed in historical cohort studies?",
      options: [
        "Prospectively",
        "Retrospectively",
        "Not at all",
        "Only for one day",
      ],
      correct: "B"
    },
    {
      id: 60232,
      question: "What can be estimated through calculation of risk in cohort studies?",
      options: [
        "Only qualitative outcomes",
        "The risk of developing the disease",
        "Only patient satisfaction",
        "Only cost of treatment",
      ],
      correct: "B"
    },
    {
      id: 60233,
      question: "What is the formula for estimated risk of disease in the exposed group?",
      options: [
        "riskexp = a/(a+b)",
        "riskexp = a/(a+c)",
        "riskexp = b/(b+d)",
        "riskexp = c/(c+d)",
      ],
      correct: "B"
    },
    {
      id: 60234,
      question: "What is the formula for estimated risk of disease in the unexposed group?",
      options: [
        "riskunexp = a/(a+c)",
        "riskunexp = a/(a+b)",
        "riskunexp = b/(b+d)",
        "riskunexp = c/(c+d)",
      ],
      correct: "C"
    },
    {
      id: 60235,
      question: "What does relative risk (RR) reveal?",
      options: [
        "The cost of treatment",
        "The altered risk of disease in relation to exposure to a relevant factor",
        "The number of participants",
        "The duration of study",
      ],
      correct: "B"
    },
    {
      id: 60236,
      question: "What is the formula for estimated relative risk?",
      options: [
        "RR = riskunexp/riskexp",
        "RR = riskexp x riskunexp",
        "RR = riskexp/riskunexp",
        "RR = riskexp + riskunexp",
      ],
      correct: "C"
    },
    {
      id: 60237,
      question: "What type of studies are case-control studies?",
      options: [
        "Prospective studies",
        "Retrospective studies",
        "Cross-sectional studies",
        "Longitudinal experimental studies",
      ],
      correct: "B"
    },
    {
      id: 60238,
      question: "What do case-control studies compare?",
      options: [
        "Different hospitals",
        "Cases (patients with disease) with controls (individuals without disease)",
        "Different researchers",
        "Different time periods only",
      ],
      correct: "B"
    },
    {
      id: 60239,
      question: "What are prevalent cases?",
      options: [
        "Patients diagnosed after recruitment",
        "Patients who were diagnosed before recruitment",
        "Patients without disease",
        "Healthy controls",
      ],
      correct: "B"
    },
    {
      id: 60240,
      question: "What are incident cases?",
      options: [
        "Patients diagnosed long before the study",
        "Patients who enter the study as soon as they are diagnosed",
        "Patients without symptoms",
        "Healthy individuals",
      ],
      correct: "B"
    },
    {
      id: 60241,
      question: "Which type of cases seem more useful in case-control studies?",
      options: [
        "Incident cases",
        "Prevalent cases",
        "Control cases",
        "Healthy cases",
      ],
      correct: "B"
    },
    {
      id: 60242,
      question: "What is usually calculated in case-control studies instead of precise risk?",
      options: [
        "Relative risk",
        "Odds ratio",
        "Correlation coefficient",
        "Standard deviation",
      ],
      correct: "B"
    },
    {
      id: 60243,
      question: "What is the formula for estimated odds ratio?",
      options: [
        "(a+b)/(c+d)",
        "(a×d)/(b×c)",
        "(a+c)/(b+d)",
        "(a-b)/(c-d)",
      ],
      correct: "B"
    },
    {
      id: 60244,
      question: "What does correlation design determine?",
      options: [
        "Cause and effect relationships",
        "Whether two variables are correlated",
        "Only qualitative data",
        "Only historical trends",
      ],
      correct: "B"
    },
    {
      id: 60245,
      question: "How many types of correlation are identified?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 60246,
      question: "What is a positive correlation?",
      options: [
        "When one variable increases and the other decreases",
        "When an increase in one variable corresponds to an increase in another variable",
        "When there is no relationship between variables",
        "When variables remain constant",
      ],
      correct: "B"
    },
    {
      id: 60247,
      question: "What is survey research usually used for?",
      options: [
        "Laboratory experiments",
        "Gathering information from a group or population regarding a specific topic",
        "Clinical trials",
        "Randomization procedures",
      ],
      correct: "B"
    },
    {
      id: 60248,
      question: "What does a researcher administer to respondents in survey research?",
      options: [
        "Medication",
        "A standardized questionnaire",
        "Treatment",
        "Intervention",
      ],
      correct: "B"
    },
    {
      id: 60249,
      question: "Which is NOT a form of questionnaire mentioned?",
      options: [
        "Written document",
        "Online questionnaire",
        "Interview",
        "Laboratory test",
      ],
      correct: "D"
    },
    {
      id: 60250,
      question: "What are longitudinal surveys?",
      options: [
        "Short-term studies",
        "Extended research performed over a fairly long period of time",
        "Studies at one point in time",
        "Studies without questionnaires",
      ],
      correct: "B"
    },
    {
      id: 60251,
      question: "How many aspects determine rigor in quantitative studies?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60252,
      question: "What is internal validity?",
      options: [
        "The ability to generalize results to larger populations",
        "The extent to which no other variables except the one being studied caused the result",
        "The reliability of questionnaires",
        "The accuracy of randomization",
      ],
      correct: "B"
    },
    {
      id: 60253,
      question: "What is external validity?",
      options: [
        "The ability to control all variables",
        "The extent to which results can be generalized to a very large population",
        "The accuracy of internal measurements",
        "The validity of questionnaires",
      ],
      correct: "B"
    },
    {
      id: 60254,
      question: "Which of the following is a type of experimental randomization?",
      options: [
        "Cohort randomization",
        "Case-control randomization",
        "Cluster randomization",
        "Survey randomization",
      ],
      correct: "C"
    },
    {
      id: 60255,
      question: "What does random allocation help avoid?",
      options: [
        "Data collection",
        "Allocation bias",
        "Patient recruitment",
        "Statistical analysis",
      ],
      correct: "B"
    },
    {
      id: 60256,
      question: "In the stratified randomization example, what were the predictive variables?",
      options: [
        "Treatment type only",
        "Gender and age",
        "Disease status only",
        "Hospital location",
      ],
      correct: "B"
    },
    {
      id: 60257,
      question: "What happens after patients enter a clinical trial?",
      options: [
        "They choose their treatment",
        "They are allocated to a treatment group randomly",
        "They are assigned by the researcher",
        "They are grouped by disease",
      ],
      correct: "B"
    },
    {
      id: 60258,
      question: "Which design studies participants at multiple points of time?",
      options: [
        "Pretest-posttest design",
        "Time series design",
        "Case-control study",
        "Cohort study",
      ],
      correct: "B"
    },
    {
      id: 60259,
      question: "What is another name for constrained randomization?",
      options: [
        "Stratified randomization",
        "Blocked randomization",
        "Cluster randomization",
        "Simple randomization",
      ],
      correct: "B"
    },
    {
      id: 60260,
      question: "What does a negative correlation indicate?",
      options: [
        "An increase in one variable corresponds to an increase in another",
        "An increase in one variable corresponds to a decrease in another",
        "No relationship between variables",
        "Variables are identical",
      ],
      correct: "B"
    },
    {
      id: 60261,
      question: "Which study design follows individuals from present time to future time?",
      options: [
        "Case-control study",
        "Cohort study",
        "Survey",
        "Correlation study",
      ],
      correct: "B"
    },
    {
      id: 60262,
      question: "Which study design traces from present time back to past time?",
      options: [
        "Cohort study",
        "Case-control study",
        "Survey",
        "Experimental study",
      ],
      correct: "B"
    },
    {
      id: 60263,
      question: "What are controls in a case-control study?",
      options: [
        "Patients with disease",
        "Individuals without disease",
        "Researchers",
        "Treatment groups",
      ],
      correct: "B"
    },
    {
      id: 60264,
      question: "What is the relationship between exposure and disease investigated in?",
      options: [
        "Survey research",
        "Cohort and case-control studies",
        "Correlation studies only",
        "Experimental studies only",
      ],
      correct: "B"
    },
    {
      id: 60265,
      question: "Who is the author of the reference textbook?",
      options: [
        "Kamyar Motavaze",
        "Davies B and Logan J",
        "Oxford College",
        "Elsevier Inc.",
      ],
      correct: "B"
    },
    {
      id: 60266,
      question: "What institution is associated with this course material?",
      options: [
        "Harvard University",
        "Cambridge University",
        "Oxford College",
        "Stanford University",
      ],
      correct: "C"
    },
    {
      id: 60267,
      question: "What edition of the reference textbook is cited?",
      options: [
        "5th edition",
        "6th edition",
        "7th edition",
        "8th edition",
      ],
      correct: "C"
    },
    {
      id: 60268,
      question: "In what year was the reference textbook published?",
      options: [
        "2019",
        "2020",
        "2021",
        "2022",
      ],
      correct: "C"
    },
    {
      id: 60269,
      question: "Which is an example of a quantitative variable?",
      options: [
        "Patient satisfaction",
        "Age",
        "Personal experience",
        "Cultural background",
      ],
      correct: "B"
    },
    {
      id: 60270,
      question: "What is population size an example of?",
      options: [
        "Qualitative variable",
        "Quantitative variable",
        "Observational data",
        "Interview response",
      ],
      correct: "B"
    },
    {
      id: 60271,
      question: "What type of study compares patients with disease to those without disease based on exposure?",
      options: [
        "Cohort study",
        "Survey",
        "Case-control study",
        "Correlation study",
      ],
      correct: "C"
    },
    {
      id: 60272,
      question: "Which quasi-experimental design involves only one group?",
      options: [
        "Time series design",
        "Pretest-posttest design",
        "Cohort study",
        "Case-control study",
      ],
      correct: "B"
    },
  ],
  "4. Quantitative Research (Part 2)": [
    {
      id: 60300,
      question: "What does the Sample section of a research paper define?",
      options: [
        "The statistical methods used",
        "The participants in the study",
        "The data analysis procedures",
        "The research conclusions",
      ],
      correct: "B"
    },
    {
      id: 60301,
      question: "Which of the following is a critical issue to clarify in the Sample section?",
      options: [
        "Statistical software used",
        "Conditions for selecting participants",
        "Publication timeline",
        "Funding sources",
      ],
      correct: "B"
    },
    {
      id: 60302,
      question: "What characteristic of participants should be described in the Sample section?",
      options: [
        "Only their names",
        "Age and gender",
        "Only their location",
        "Only their occupation",
      ],
      correct: "B"
    },
    {
      id: 60303,
      question: "Which aspect of selection may affect study outcome?",
      options: [
        "Researcher\'s favorite color",
        "Socioeconomic situation or geographical location",
        "Time of publication",
        "Journal selection",
      ],
      correct: "B"
    },
    {
      id: 60304,
      question: "Why is information about sample size important?",
      options: [
        "To determine publication fees",
        "To compare one treatment program with another",
        "To select the journal",
        "To choose the title",
      ],
      correct: "B"
    },
    {
      id: 60305,
      question: "If 50 people out of 100 have a disease versus 1000 people out of 2000, what is the percentage in both cases?",
      options: [
        "25%",
        "40%",
        "50%",
        "75%",
      ],
      correct: "C"
    },
    {
      id: 60306,
      question: "Even though percentages may be the same, what might be different?",
      options: [
        "The disease name",
        "The interpretation of results",
        "The researcher\'s name",
        "The publication date",
      ],
      correct: "B"
    },
    {
      id: 60307,
      question: "What must research papers report regarding sample size?",
      options: [
        "Only the total number",
        "Calculations to determine sufficiency in detecting clinically substantial differences",
        "Only demographic data",
        "Only age distribution",
      ],
      correct: "B"
    },
    {
      id: 60308,
      question: "What is a key issue regarding sample size and outcomes?",
      options: [
        "The researcher\'s experience",
        "The frequency of the main outcome",
        "The publication venue",
        "The funding amount",
      ],
      correct: "B"
    },
    {
      id: 60309,
      question: "What type of outcomes require larger samples?",
      options: [
        "Common outcomes",
        "Uncommon outcomes",
        "Expected outcomes",
        "Positive outcomes",
      ],
      correct: "B"
    },
    {
      id: 60310,
      question: "What is statistical power?",
      options: [
        "The cost of the research",
        "The ability of research to identify noticeable differences",
        "The number of researchers",
        "The duration of the study",
      ],
      correct: "B"
    },
    {
      id: 60311,
      question: "What does a power of 0.85 (85%) indicate?",
      options: [
        "85% of participants completed the study",
        "A statistically significant impact in 85 trials if an effective treatment is repeated 100 times",
        "85% of the budget was used",
        "85% of researchers agreed",
      ],
      correct: "B"
    },
    {
      id: 60312,
      question: "What is an acceptable statistical power?",
      options: [
        "≥50%",
        "≥60%",
        "≥70%",
        "≥80%",
      ],
      correct: "D"
    },
    {
      id: 60313,
      question: "What p-value indicates statistical significance?",
      options: [
        "p-value ≤0.10",
        "p-value ≤0.05",
        "p-value ≤0.50",
        "p-value ≤0.25",
      ],
      correct: "B"
    },
    {
      id: 60314,
      question: "What does the Data Collection section explain?",
      options: [
        "Only the results",
        "The specific method(s) to obtain information",
        "Only the conclusions",
        "Only the abstract",
      ],
      correct: "B"
    },
    {
      id: 60315,
      question: "How many important concepts must be considered in Data Collection?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six",
      ],
      correct: "D"
    },
    {
      id: 60316,
      question: "Which is one of the first three concepts in Data Collection?",
      options: [
        "What is the funding source?",
        "What data were collected?",
        "Who published the research?",
        "When was it submitted?",
      ],
      correct: "B"
    },
    {
      id: 60317,
      question: "What is the setting for data collection an example of?",
      options: [
        "A statistical method",
        "An important concept in Data Collection",
        "A type of analysis",
        "A publication requirement",
      ],
      correct: "B"
    },
    {
      id: 60318,
      question: "What aspect of trustworthiness should be considered in Data Collection?",
      options: [
        "Cost of materials",
        "Reliability of the materials and tools",
        "Color of equipment",
        "Brand of software",
      ],
      correct: "B"
    },
    {
      id: 60319,
      question: "Which of the following may affect research outcome?",
      options: [
        "Font size of the paper",
        "Time, location, and/or biased researcher",
        "Paper quality",
        "Number of pages",
      ],
      correct: "B"
    },
    {
      id: 60320,
      question: "What should be checked regarding treatment across study groups?",
      options: [
        "Cost of treatment",
        "Inequality of treatment",
        "Color of medication",
        "Packaging of treatment",
      ],
      correct: "B"
    },
    {
      id: 60321,
      question: "How many common types of reliability in quantitative methods are identified?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 60322,
      question: "What is inter-rater reliability?",
      options: [
        "Reliability confirmed at different times",
        "Trustworthiness of a tool affirmed by two or more researchers",
        "Internal consistency of items",
        "Test accuracy over time",
      ],
      correct: "B"
    },
    {
      id: 60323,
      question: "What is an example of inter-rater reliability?",
      options: [
        "Testing the same person twice",
        "Evaluation of infection control in an OR by two investigators",
        "Measuring internal consistency",
        "Calculating Cronbach\'s alpha",
      ],
      correct: "B"
    },
    {
      id: 60324,
      question: "What is test-retest reliability?",
      options: [
        "Reliability affirmed by multiple researchers",
        "Rigor of a tool confirmed under the same conditions but at different times",
        "Internal consistency measurement",
        "Sensitivity calculation",
      ],
      correct: "B"
    },
    {
      id: 60325,
      question: "What does internal consistency describe?",
      options: [
        "How different items are from each other",
        "How closely related a set of items are as a group",
        "How reliable different researchers are",
        "How consistent time measurements are",
      ],
      correct: "B"
    },
    {
      id: 60326,
      question: "What is the evaluation of internal consistency called?",
      options: [
        "Inter-rater reliability",
        "Test-retest reliability",
        "Cronbach\'s alpha",
        "Specificity",
      ],
      correct: "C"
    },
    {
      id: 60327,
      question: "What is an acceptable Cronbach\'s alpha value?",
      options: [
        "≥0.50",
        "≥0.60",
        "≥0.70",
        "≥0.90",
      ],
      correct: "C"
    },
    {
      id: 60328,
      question: "In the depression survey example, which item shows lack of consistency?",
      options: [
        "Weight loss",
        "Common cold",
        "Anorexia",
        "Sleep problems",
      ],
      correct: "B"
    },
    {
      id: 60329,
      question: "What are two characteristics of diagnostic tools and methods?",
      options: [
        "Cost and availability",
        "Sensitivity and specificity",
        "Size and weight",
        "Color and shape",
      ],
      correct: "B"
    },
    {
      id: 60330,
      question: "What does sensitivity indicate?",
      options: [
        "How often a test is negative when disease is present",
        "How often a test is positive when a person has a disease",
        "How often a test fails",
        "How expensive the test is",
      ],
      correct: "B"
    },
    {
      id: 60331,
      question: "What is sensitivity also known as?",
      options: [
        "True negative rate",
        "True positive rate",
        "False positive rate",
        "False negative rate",
      ],
      correct: "B"
    },
    {
      id: 60332,
      question: "What is the formula for sensitivity?",
      options: [
        "True positives/(true positive + false positive)",
        "True positives/(true positive + false negative)",
        "True negatives/(true negative + false positive)",
        "True negatives/(true negative + false negative)",
      ],
      correct: "B"
    },
    {
      id: 60333,
      question: "What does specificity indicate?",
      options: [
        "How often a test is positive when disease is absent",
        "How often a test is negative when a person does not have a disease",
        "How often a test is positive when disease is present",
        "How sensitive the test is",
      ],
      correct: "B"
    },
    {
      id: 60334,
      question: "What is specificity also known as?",
      options: [
        "True positive rate",
        "False negative rate",
        "True negative rate",
        "False positive rate",
      ],
      correct: "C"
    },
    {
      id: 60335,
      question: "What is the formula for specificity?",
      options: [
        "True negatives/(true negative + false positives)",
        "True positives/(true positive + false negative)",
        "True negatives/(true negative + false negative)",
        "True positives/(true positive + false positive)",
      ],
      correct: "A"
    },
    {
      id: 60336,
      question: "What does the Data Analysis and Results section explain?",
      options: [
        "Only participant demographics",
        "Statistical analyses used to interpret data and results",
        "Only funding sources",
        "Only ethical considerations",
      ],
      correct: "B"
    },
    {
      id: 60337,
      question: "Which is a key issue to clarify in Data Analysis and Results?",
      options: [
        "What was the budget?",
        "What methods were used for data analysis?",
        "Who funded the study?",
        "Where was it published?",
      ],
      correct: "B"
    },
    {
      id: 60338,
      question: "What should be provided for the results?",
      options: [
        "Only a brief summary",
        "A complete explanation of the results",
        "Only statistical values",
        "Only graphs",
      ],
      correct: "B"
    },
    {
      id: 60339,
      question: "In the mammogram example, how many true positives were there?",
      options: [
        "10",
        "4995",
        "90",
        "94905",
      ],
      correct: "C"
    },
    {
      id: 60340,
      question: "In the mammogram example, how many false negatives were there?",
      options: [
        "90",
        "10",
        "4995",
        "94905",
      ],
      correct: "B"
    },
    {
      id: 60341,
      question: "In the mammogram example, how many false positives were there?",
      options: [
        "90",
        "10",
        "4995",
        "94905",
      ],
      correct: "C"
    },
    {
      id: 60342,
      question: "In the mammogram example, how many true negatives were there?",
      options: [
        "90",
        "10",
        "4995",
        "94905",
      ],
      correct: "D"
    },
    {
      id: 60343,
      question: "Using the mammogram data, what is the sensitivity?",
      options: [
        "90/(90+10) = 90%",
        "90/(90+4995)",
        "94905/(94905+4995)",
        "10/(10+90)",
      ],
      correct: "A"
    },
    {
      id: 60344,
      question: "Using the mammogram data, what is the specificity?",
      options: [
        "90/(90+10)",
        "4995/(4995+94905)",
        "94905/(94905+4995)",
        "10/(10+4995)",
      ],
      correct: "C"
    },
    {
      id: 60345,
      question: "What type of reliability involves the same tool used at different times?",
      options: [
        "Inter-rater reliability",
        "Test-retest reliability",
        "Internal consistency",
        "External validity",
      ],
      correct: "B"
    },
    {
      id: 60346,
      question: "What type of reliability involves multiple researchers evaluating the same thing?",
      options: [
        "Test-retest reliability",
        "Internal consistency",
        "Inter-rater reliability",
        "Cronbach\'s alpha",
      ],
      correct: "C"
    },
    {
      id: 60347,
      question: "Which reliability type uses Cronbach\'s alpha for evaluation?",
      options: [
        "Inter-rater reliability",
        "Test-retest reliability",
        "Internal consistency",
        "External validity",
      ],
      correct: "C"
    },
    {
      id: 60348,
      question: "What does a Cronbach\'s alpha of 0.75 indicate?",
      options: [
        "Unacceptable internal consistency",
        "Acceptable internal consistency",
        "Perfect internal consistency",
        "No internal consistency",
      ],
      correct: "B"
    },
    {
      id: 60349,
      question: "What does a Cronbach\'s alpha of 0.65 indicate?",
      options: [
        "Acceptable internal consistency",
        "Below acceptable internal consistency",
        "Perfect internal consistency",
        "Excellent internal consistency",
      ],
      correct: "B"
    },
    {
      id: 60350,
      question: "Why might the interpretation of 50/100 differ from 1000/2000?",
      options: [
        "Different percentages",
        "Different sample sizes affect reliability of interpretation",
        "Different diseases",
        "Different researchers",
      ],
      correct: "B"
    },
    {
      id: 60351,
      question: "What is the basis for sample size one of the critical issues in?",
      options: [
        "Data analysis",
        "Results section",
        "Sample section",
        "Abstract",
      ],
      correct: "C"
    },
    {
      id: 60352,
      question: "Who is the author of the reference textbook?",
      options: [
        "Kamyar Motavaze",
        "Davies B and Logan J",
        "Oxford College",
        "Elsevier Inc.",
      ],
      correct: "B"
    },
    {
      id: 60353,
      question: "What institution is associated with this course material?",
      options: [
        "Harvard University",
        "Stanford University",
        "Oxford College",
        "Cambridge University",
      ],
      correct: "C"
    },
    {
      id: 60354,
      question: "What edition of the reference textbook is cited?",
      options: [
        "5th edition",
        "6th edition",
        "7th edition",
        "8th edition",
      ],
      correct: "C"
    },
    {
      id: 60355,
      question: "In what year was the reference textbook published?",
      options: [
        "2019",
        "2020",
        "2021",
        "2022",
      ],
      correct: "C"
    },
    {
      id: 60356,
      question: "A statistical power of 80% means what?",
      options: [
        "The study is 80% complete",
        "The study can detect differences in 80 out of 100 trials",
        "80% of participants completed the study",
        "The budget is 80% used",
      ],
      correct: "B"
    },
    {
      id: 60357,
      question: "What affects whether a sample size is sufficient?",
      options: [
        "Only the researcher\'s preference",
        "The ability to detect clinically substantial differences",
        "Only the funding available",
        "Only the time available",
      ],
      correct: "B"
    },
    {
      id: 60358,
      question: "What is NOT one of the six concepts in Data Collection?",
      options: [
        "What data were collected",
        "How were data collected",
        "What is the publication fee",
        "Setting for data collection",
      ],
      correct: "C"
    },
    {
      id: 60359,
      question: "In the depression survey example, which items ARE consistent with depression assessment?",
      options: [
        "Only common cold",
        "Interest in outdoor activities, weight loss, anorexia, sleep problems",
        "Only common cold and weight loss",
        "Only sleep problems",
      ],
      correct: "B"
    },
    {
      id: 60360,
      question: "What does \"rigor\" refer to in test-retest reliability?",
      options: [
        "Cost of the test",
        "Strictness and accuracy of the tool or method",
        "Speed of the test",
        "Size of the sample",
      ],
      correct: "B"
    },
    {
      id: 60361,
      question: "What is affirmed when two investigators evaluate infection control?",
      options: [
        "Test-retest reliability",
        "Internal consistency",
        "Inter-rater reliability",
        "Specificity",
      ],
      correct: "C"
    },
    {
      id: 60362,
      question: "What happens when statistical power is below 80%?",
      options: [
        "The study is automatically valid",
        "The study may not reliably detect differences",
        "The study is automatically published",
        "The sample size is perfect",
      ],
      correct: "B"
    },
  ],
  "5. Probability and Nonprobability Sampling Methods": [
    {
      id: 60400,
      question: "What are the two main types of sampling?",
      options: [
        "Random and systematic",
        "Probability and nonprobability sampling",
        "Stratified and cluster",
        "Convenience and quota",
      ],
      correct: "B"
    },
    {
      id: 60401,
      question: "In probability sampling, what opportunity does each member have?",
      options: [
        "Unequal opportunity based on characteristics",
        "No opportunity to be selected",
        "An equal opportunity to be selected",
        "Opportunity based on researcher preference",
      ],
      correct: "C"
    },
    {
      id: 60402,
      question: "What is probability sampling also known as?",
      options: [
        "Convenience sampling",
        "Random sampling",
        "Quota sampling",
        "Purposive sampling",
      ],
      correct: "B"
    },
    {
      id: 60403,
      question: "How many common designs exist for random sampling?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 60404,
      question: "Which of the following is NOT a type of probability sampling?",
      options: [
        "Stratified random sampling",
        "Simple random sampling",
        "Convenience sampling",
        "Cluster random sampling",
      ],
      correct: "C"
    },
    {
      id: 60405,
      question: "What is stratified random sampling based on?",
      options: [
        "Random selection without any criteria",
        "Categorization of participants into selected strata",
        "Researcher preference",
        "Geographic location only",
      ],
      correct: "B"
    },
    {
      id: 60406,
      question: "What are examples of strata in stratified random sampling?",
      options: [
        "Time and location",
        "Age and gender",
        "Cost and duration",
        "Sample size and power",
      ],
      correct: "B"
    },
    {
      id: 60407,
      question: "In simple random sampling, what does each member have?",
      options: [
        "Different probabilities of selection",
        "No chance of selection",
        "An equal probability of being selected",
        "Priority based on age",
      ],
      correct: "C"
    },
    {
      id: 60408,
      question: "What is one common way to achieve simple random sampling?",
      options: [
        "Selecting participants by preference",
        "Assigning each subject a number and randomly selecting numbers",
        "Choosing the first volunteers",
        "Selecting based on location",
      ],
      correct: "B"
    },
    {
      id: 60409,
      question: "What is cluster random sampling also referred to as?",
      options: [
        "Simple sampling",
        "Complex sampling",
        "Quota sampling",
        "Convenience sampling",
      ],
      correct: "B"
    },
    {
      id: 60410,
      question: "When is cluster random sampling used?",
      options: [
        "When all population elements are known",
        "When time and travel for simple random sampling would be unreasonable",
        "When sample size is very small",
        "When only one participant is needed",
      ],
      correct: "B"
    },
    {
      id: 60411,
      question: "What is another situation where cluster sampling is appropriate?",
      options: [
        "When population elements are well documented",
        "When specific elements of a population are unknown",
        "When only one location is studied",
        "When time is unlimited",
      ],
      correct: "B"
    },
    {
      id: 60412,
      question: "To perform cluster sampling, what list is developed?",
      options: [
        "Only participant names",
        "All states, cities, and institutions",
        "Only age groups",
        "Only gender categories",
      ],
      correct: "B"
    },
    {
      id: 60413,
      question: "What does systematic random sampling require?",
      options: [
        "No list of members",
        "A complete list of all members of the population",
        "Only partial information",
        "Random guessing",
      ],
      correct: "B"
    },
    {
      id: 60414,
      question: "How are sample members selected in systematic sampling?",
      options: [
        "By researcher preference",
        "According to a random starting point and fixed periodic interval",
        "By alphabetical order only",
        "By age only",
      ],
      correct: "B"
    },
    {
      id: 60415,
      question: "What is the sampling interval?",
      options: [
        "The time between samples",
        "The population size divided by the desired sample size",
        "The number of researchers",
        "The duration of the study",
      ],
      correct: "B"
    },
    {
      id: 60416,
      question: "If a population is 1000 and desired sample size is 100, what is the sampling interval?",
      options: [
        "5",
        "10",
        "15",
        "20",
      ],
      correct: "B"
    },
    {
      id: 60417,
      question: "With a sampling interval of 10, who is invited to participate?",
      options: [
        "Every 5th person",
        "Every 10th person",
        "Every 15th person",
        "Every 20th person",
      ],
      correct: "B"
    },
    {
      id: 60418,
      question: "In nonprobability sampling, what opportunity do members have?",
      options: [
        "Equal opportunities to be selected",
        "Unequal opportunities to be selected",
        "Guaranteed selection",
        "Random selection",
      ],
      correct: "B"
    },
    {
      id: 60419,
      question: "Which nonprobability methods are used in quantitative research?",
      options: [
        "Purposive and network",
        "Convenience and quota",
        "Theoretical and purposive",
        "Network and theoretical",
      ],
      correct: "B"
    },
    {
      id: 60420,
      question: "Which nonprobability methods are used in qualitative research?",
      options: [
        "Convenience and quota",
        "Simple and stratified",
        "Purposive, network, and theoretical",
        "Cluster and systematic",
      ],
      correct: "C"
    },
    {
      id: 60421,
      question: "What is convenience sampling?",
      options: [
        "Selecting based on specific criteria",
        "Enrolling individuals who are in the right time and/or right place",
        "Using social networks to recruit",
        "Gathering data to create theory",
      ],
      correct: "B"
    },
    {
      id: 60422,
      question: "What does quota sampling ensure?",
      options: [
        "Random selection of all members",
        "Sufficient representation of underrepresented individuals",
        "Equal probability for everyone",
        "Maximum sample size",
      ],
      correct: "B"
    },
    {
      id: 60423,
      question: "Who are examples of underrepresented individuals in quota sampling?",
      options: [
        "Wealthy individuals",
        "Poor and minorities",
        "Researchers",
        "Healthcare providers",
      ],
      correct: "B"
    },
    {
      id: 60424,
      question: "What is purposive sampling?",
      options: [
        "Random selection of participants",
        "Choosing specific criteria intentionally to obtain typical and atypical cases",
        "Using social networks",
        "Creating theory from data",
      ],
      correct: "B"
    },
    {
      id: 60425,
      question: "What is network sampling?",
      options: [
        "Selecting participants randomly",
        "Using social networks and asking participants to recruit others with same characteristics",
        "Choosing based on convenience",
        "Selecting underrepresented groups",
      ],
      correct: "B"
    },
    {
      id: 60426,
      question: "What is theoretical sampling used for?",
      options: [
        "Random selection",
        "Gathering data from individuals to create theory",
        "Ensuring equal representation",
        "Convenience of researcher",
      ],
      correct: "B"
    },
    {
      id: 60427,
      question: "In Study Excerpt 1, what sampling method was used when participants were asked to refer other elders?",
      options: [
        "Simple random sampling",
        "Stratified sampling",
        "Network sampling",
        "Systematic sampling",
      ],
      correct: "C"
    },
    {
      id: 60428,
      question: "In Study Excerpt 2, what type of sampling was used when subjects were recruited through newspaper advertisements?",
      options: [
        "Stratified random sampling",
        "Convenience sampling",
        "Cluster sampling",
        "Systematic sampling",
      ],
      correct: "B"
    },
    {
      id: 60429,
      question: "In Study Excerpt 3, what sampling method selected every seventh nurse?",
      options: [
        "Simple random sampling",
        "Stratified sampling",
        "Systematic random sampling",
        "Cluster sampling",
      ],
      correct: "C"
    },
    {
      id: 60430,
      question: "In Study Excerpt 4, what type of sampling randomly selected women from census blocks?",
      options: [
        "Convenience sampling",
        "Quota sampling",
        "Cluster random sampling",
        "Network sampling",
      ],
      correct: "C"
    },
    {
      id: 60431,
      question: "In Study Excerpt 5, patients were stratified by what factor?",
      options: [
        "Gender",
        "Age (< or ≥ 60 years)",
        "Location",
        "Income",
      ],
      correct: "B"
    },
    {
      id: 60432,
      question: "In Study Excerpt 6, what percentage of invited students participated in the DANDY cohort?",
      options: [
        "76%",
        "85%",
        "94%",
        "100%",
      ],
      correct: "C"
    },
    {
      id: 60433,
      question: "In Study Excerpt 7, how many NPs and PAs were randomly selected?",
      options: [
        "1,950 each",
        "2,000 each",
        "3,000 each",
        "3,900 each",
      ],
      correct: "A"
    },
    {
      id: 60434,
      question: "In Study Excerpt 8, participants were selected to allow diversity in which factors?",
      options: [
        "Only age",
        "Ages, gender, and ethnicity",
        "Only location",
        "Only income",
      ],
      correct: "B"
    },
    {
      id: 60435,
      question: "What type of sampling was used in Study Excerpt 8 to capture information-rich data?",
      options: [
        "Simple random sampling",
        "Systematic sampling",
        "Purposive sampling",
        "Quota sampling",
      ],
      correct: "C"
    },
    {
      id: 60436,
      question: "In Study Excerpt 9, how were participants recruited?",
      options: [
        "Through random selection",
        "Through personal acquaintances and professional contacts",
        "Through systematic sampling",
        "Through stratified sampling",
      ],
      correct: "B"
    },
    {
      id: 60437,
      question: "What sampling method does Study Excerpt 9 demonstrate?",
      options: [
        "Simple random sampling",
        "Convenience sampling",
        "Stratified sampling",
        "Cluster sampling",
      ],
      correct: "B"
    },
    {
      id: 60438,
      question: "In Study Excerpt 10, patients with what baseline hemoglobin A1c level were invited?",
      options: [
        "≥5.5%",
        "≥6.5%",
        "≥7.5%",
        "≥8.5%",
      ],
      correct: "C"
    },
    {
      id: 60439,
      question: "In Study Excerpt 11, what methodology was used to identify apartments?",
      options: [
        "Convenience sampling",
        "Random sampling methodology",
        "Quota sampling",
        "Network sampling",
      ],
      correct: "B"
    },
    {
      id: 60440,
      question: "What type of study was described in Study Excerpt 11?",
      options: [
        "Qualitative study",
        "Quasi-experimental study",
        "Case-control study",
        "Cohort study",
      ],
      correct: "B"
    },
    {
      id: 60441,
      question: "In Study Excerpt 12, where were patients recruited from?",
      options: [
        "Private clinics",
        "Pulmonary department at university and county hospitals",
        "Community centers",
        "Schools",
      ],
      correct: "B"
    },
    {
      id: 60442,
      question: "What sampling method does Study Excerpt 12 represent?",
      options: [
        "Random sampling",
        "Stratified sampling",
        "Convenience sampling",
        "Cluster sampling",
      ],
      correct: "C"
    },
    {
      id: 60443,
      question: "In Study Excerpt 13, what nonprobability technique was used to locate difficult-to-find population members?",
      options: [
        "Convenience sampling",
        "Quota sampling",
        "Network sampling",
        "Purposive sampling",
      ],
      correct: "C"
    },
    {
      id: 60444,
      question: "Where were participants in Study Excerpt 13 recruited from?",
      options: [
        "Only hospitals",
        "Parks, streets, prisons, methadone therapy, and drop-in centers",
        "Only schools",
        "Only clinics",
      ],
      correct: "B"
    },
    {
      id: 60445,
      question: "In Study Excerpt 14, how were participants recruited after the tornado?",
      options: [
        "Through random selection",
        "Through advertisements in newspapers and flyers in churches",
        "Through systematic sampling",
        "Through stratified sampling",
      ],
      correct: "B"
    },
    {
      id: 60446,
      question: "What type of sampling does Study Excerpt 14 demonstrate?",
      options: [
        "Stratified random sampling",
        "Convenience sampling",
        "Systematic sampling",
        "Cluster sampling",
      ],
      correct: "B"
    },
    {
      id: 60447,
      question: "In Study Excerpt 15, how many patients were included in the ALPAM study?",
      options: [
        "298",
        "312",
        "500",
        "610",
      ],
      correct: "D"
    },
    {
      id: 60448,
      question: "What type of sampling was the hospital selection in Study Excerpt 15?",
      options: [
        "Stratified sampling",
        "Convenience sampling",
        "Systematic sampling",
        "Cluster sampling",
      ],
      correct: "B"
    },
    {
      id: 60449,
      question: "How were patients at risk assigned in Study Excerpt 15?",
      options: [
        "By researcher preference",
        "Randomly assigned",
        "By age only",
        "By location only",
      ],
      correct: "B"
    },
    {
      id: 60450,
      question: "In Study Excerpt 16, what was the initial sampling method?",
      options: [
        "Random sampling",
        "Purposive sampling",
        "Convenience sampling",
        "Systematic sampling",
      ],
      correct: "B"
    },
    {
      id: 60451,
      question: "What was the goal of additional sampling in Study Excerpt 16?",
      options: [
        "To increase sample size",
        "To achieve theoretical saturation",
        "To reduce costs",
        "To speed up data collection",
      ],
      correct: "B"
    },
    {
      id: 60452,
      question: "What defines theoretical saturation according to Study Excerpt 16?",
      options: [
        "Maximum sample size reached",
        "No new properties of categories are identified",
        "All participants interviewed",
        "Budget exhausted",
      ],
      correct: "B"
    },
    {
      id: 60453,
      question: "In Study Excerpt 17, what type of design was used?",
      options: [
        "Retrospective quantitative design",
        "Prospective qualitative descriptive design",
        "Cross-sectional design",
        "Experimental design",
      ],
      correct: "B"
    },
    {
      id: 60454,
      question: "What sampling technique was used in Study Excerpt 17?",
      options: [
        "Simple random sampling",
        "Purposive sampling with maximum variation",
        "Convenience sampling",
        "Quota sampling",
      ],
      correct: "B"
    },
    {
      id: 60455,
      question: "In Study Excerpt 17, ethnicity was stratified into which groups?",
      options: [
        "Hispanic and Asian",
        "African American and Caucasian",
        "European and Asian",
        "Native American and Hispanic",
      ],
      correct: "B"
    },
    {
      id: 60456,
      question: "How was socioeconomic status stratified in Study Excerpt 17?",
      options: [
        "By income level",
        "By presence or absence of private insurance",
        "By education level",
        "By occupation",
      ],
      correct: "B"
    },
    {
      id: 60457,
      question: "What is the key difference between probability and nonprobability sampling?",
      options: [
        "Sample size",
        "Equal versus unequal opportunity for selection",
        "Cost of research",
        "Duration of study",
      ],
      correct: "B"
    },
    {
      id: 60458,
      question: "Which sampling method uses a fixed periodic interval?",
      options: [
        "Simple random sampling",
        "Stratified random sampling",
        "Systematic random sampling",
        "Cluster random sampling",
      ],
      correct: "C"
    },
    {
      id: 60459,
      question: "Which sampling method categorizes participants into strata before selection?",
      options: [
        "Simple random sampling",
        "Stratified random sampling",
        "Systematic random sampling",
        "Convenience sampling",
      ],
      correct: "B"
    },
    {
      id: 60460,
      question: "Which nonprobability method asks participants to recruit others?",
      options: [
        "Convenience sampling",
        "Quota sampling",
        "Network sampling",
        "Theoretical sampling",
      ],
      correct: "C"
    },
    {
      id: 60461,
      question: "Which sampling method is appropriate when population elements are unknown?",
      options: [
        "Simple random sampling",
        "Systematic sampling",
        "Cluster random sampling",
        "Stratified sampling",
      ],
      correct: "C"
    },
    {
      id: 60462,
      question: "What is the reference textbook for this material?",
      options: [
        "Reading Research by Davies and Logan",
        "Statistics for Nursing Research by Grove and Cipher",
        "Research Methods by Motavaze",
        "Sampling Methods by Oxford",
      ],
      correct: "B"
    },
    {
      id: 60463,
      question: "What edition of the reference textbook is cited?",
      options: [
        "1st edition",
        "2nd edition",
        "3rd edition",
        "4th edition",
      ],
      correct: "B"
    },
    {
      id: 60464,
      question: "In what year was the reference textbook published?",
      options: [
        "2014",
        "2015",
        "2016",
        "2017",
      ],
      correct: "C"
    },
    {
      id: 60465,
      question: "What institution is associated with this course material?",
      options: [
        "Harvard University",
        "Stanford University",
        "Oxford College",
        "Cambridge University",
      ],
      correct: "C"
    },
    {
      id: 60466,
      question: "How many types of nonprobability sampling are used in qualitative research?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 60467,
      question: "How many types of nonprobability sampling are used in quantitative research?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 60468,
      question: "In convenience sampling, what determines participant selection?",
      options: [
        "Random numbers",
        "Being in the right time and/or place",
        "Stratification criteria",
        "Social networks",
      ],
      correct: "B"
    },
    {
      id: 60469,
      question: "What makes cluster sampling \"complex\"?",
      options: [
        "It requires more calculations",
        "It involves selecting groups rather than individuals",
        "It is more expensive",
        "It takes longer",
      ],
      correct: "B"
    },
    {
      id: 60470,
      question: "Which sampling method is best when you need to ensure minority representation?",
      options: [
        "Simple random sampling",
        "Convenience sampling",
        "Quota sampling",
        "Cluster sampling",
      ],
      correct: "C"
    },
    {
      id: 60471,
      question: "What characteristic defines purposive sampling?",
      options: [
        "Random selection",
        "Intentional selection based on specific criteria",
        "Selection by convenience",
        "Selection through networks",
      ],
      correct: "B"
    },
  ],
  "6. Mixed Research": [
    {
      id: 60550,
      question: "What is the primary advantage of mixed methods research?",
      options: [
        "It is faster than using a single method",
        "It takes advantage of using multiple ways to explore a research problem",
        "It requires fewer investigators",
        "It eliminates the need for qualitative data",
      ],
      correct: "B"
    },
    {
      id: 60551,
      question: "For healthcare professionals and public health investigators, what trend is becoming more common?",
      options: [
        "Using only quantitative designs",
        "Avoiding qualitative research entirely",
        "Using both quantitative and qualitative designs in the same project",
        "Relying solely on case studies",
      ],
      correct: "C"
    },
    {
      id: 60552,
      question: "Why does mixed method research typically require more investigators?",
      options: [
        "Because it is more expensive",
        "Because there should be different scientists with specific expertise",
        "Because it takes longer to complete",
        "Because regulations require it",
      ],
      correct: "B"
    },
    {
      id: 60553,
      question: "What type of answers does mixed method research usually deliver regarding health issues?",
      options: [
        "More comprehensive answers",
        "Simpler answers",
        "Faster answers",
        "Less reliable answers",
      ],
      correct: "A"
    },
    {
      id: 60554,
      question: "According to the five characteristics of mixed research, what can research methods be based on?",
      options: [
        "Only quantitative standpoints",
        "Only qualitative standpoints",
        "Either or both standpoints",
        "Neither standpoint",
      ],
      correct: "C"
    },
    {
      id: 60555,
      question: "In mixed research, how can research problems become expressed?",
      options: [
        "Only as hypotheses",
        "Only as research questions",
        "As hypothesis and/or research questions based on prior knowledge and literature",
        "Only through statistical analysis",
      ],
      correct: "C"
    },
    {
      id: 60556,
      question: "What is true about sample sizes in mixed methods research?",
      options: [
        "They must be exactly equal for both methods",
        "They differ enormously",
        "They must be small",
        "They must be large",
      ],
      correct: "B"
    },
    {
      id: 60557,
      question: "In mixed methods research, what can data collection involve?",
      options: [
        "Only surveys",
        "Only interviews",
        "Any relevant technique",
        "Only observation",
      ],
      correct: "C"
    },
    {
      id: 60558,
      question: "What is true about interpretation in mixed methods research?",
      options: [
        "It occurs only at the end",
        "It is continual",
        "It is not necessary",
        "It happens only once",
      ],
      correct: "B"
    },
    {
      id: 60559,
      question: "What does \"Timing\" refer to in the four decisions for mixed method designs?",
      options: [
        "How long the research takes",
        "The order of data collection for quantitative and qualitative phases",
        "When to publish results",
        "The deadline for completion",
      ],
      correct: "B"
    },
    {
      id: 60560,
      question: "What does \"Weighting\" determine in mixed method designs?",
      options: [
        "The physical weight of documents",
        "What method has priority during data collection and analysis",
        "The number of participants",
        "The cost of the research",
      ],
      correct: "B"
    },
    {
      id: 60561,
      question: "What does \"Integration\" address in mixed method designs?",
      options: [
        "How researchers work together",
        "What is the integration point and how are the two different phases combined",
        "How data is stored",
        "How funding is distributed",
      ],
      correct: "B"
    },
    {
      id: 60562,
      question: "What does the \"Theory\" decision in mixed method designs consider?",
      options: [
        "Whether a theoretical perception will be used and if a theory is orienting the study",
        "How to teach the findings",
        "Which journal to publish in",
        "How to train new researchers",
      ],
      correct: "A"
    },
    {
      id: 60563,
      question: "Which is an advantage of mixed method research?",
      options: [
        "It is always faster",
        "It provides strong points that offset the weaknesses of both quantitative and qualitative research",
        "It requires fewer resources",
        "It eliminates the need for statistical analysis",
      ],
      correct: "B"
    },
    {
      id: 60564,
      question: "What can mixed method research deliver in terms of implementation?",
      options: [
        "A method for developing better and more specific implementation",
        "Faster implementation only",
        "Cheaper implementation",
        "Automated implementation",
      ],
      correct: "A"
    },
    {
      id: 60565,
      question: "How does mixed method research explain findings?",
      options: [
        "Less comprehensively than single methods",
        "More comprehensively than either quantitative or qualitative methods alone",
        "Only through numbers",
        "Only through narratives",
      ],
      correct: "B"
    },
    {
      id: 60566,
      question: "Which is a disadvantage of mixed method research?",
      options: [
        "It is too simple",
        "It is inaccurate in resolving inconsistencies that arise in the interpretation of the results",
        "It provides too few findings",
        "It is never published",
      ],
      correct: "B"
    },
    {
      id: 60567,
      question: "Why is planning one method by drawing on findings of another considered a disadvantage?",
      options: [
        "It is too easy",
        "It is difficult",
        "It is illegal",
        "It is unnecessary",
      ],
      correct: "B"
    },
    {
      id: 60568,
      question: "What is true about the research design in mixed method research?",
      options: [
        "It is simple",
        "It is too complex",
        "It is automated",
        "It is standardized",
      ],
      correct: "B"
    },
    {
      id: 60569,
      question: "How do the time and resources required for mixed method research compare to single methods?",
      options: [
        "Less time and resources",
        "The same time and resources",
        "More time and resources than needed for either qualitative or quantitative methods alone",
        "No time or resources needed",
      ],
      correct: "C"
    },
    {
      id: 60570,
      question: "What are the two types of design for data collection and analysis in mixed methods research?",
      options: [
        "Primary and secondary",
        "Sequential and concurrent",
        "Simple and complex",
        "Internal and external",
      ],
      correct: "B"
    },
    {
      id: 60571,
      question: "In sequential design, how is the data handled?",
      options: [
        "Combined immediately",
        "Kept separate but closely related to each other",
        "Discarded after analysis",
        "Shared with other researchers",
      ],
      correct: "B"
    },
    {
      id: 60572,
      question: "What does the explanatory strategy begin with in sequential design?",
      options: [
        "Qualitative data collection and analysis",
        "Quantitative data collection and analysis followed by qualitative",
        "Literature review only",
        "Hypothesis testing only",
      ],
      correct: "B"
    },
    {
      id: 60573,
      question: "What does the exploratory strategy begin with in sequential design?",
      options: [
        "Quantitative data collection and analysis",
        "Qualitative data collection and analysis followed by quantitative",
        "Statistical analysis",
        "Survey distribution",
      ],
      correct: "B"
    },
    {
      id: 60574,
      question: "In concurrent design, how are both sets of data handled?",
      options: [
        "Kept completely separate",
        "Combined",
        "Discarded",
        "Archived",
      ],
      correct: "B"
    },
    {
      id: 60575,
      question: "What characterizes the triangulation strategy in concurrent design?",
      options: [
        "Only quantitative data is collected",
        "Data collection and analysis of both quantitative and qualitative phases simultaneously with equal weight",
        "Only qualitative data is prioritized",
        "Data is collected at different times",
      ],
      correct: "B"
    },
    {
      id: 60576,
      question: "How is weight considered in the triangulation strategy?",
      options: [
        "Qualitative has more weight",
        "Quantitative has more weight",
        "Equal weight is considered for both portions",
        "Weight is not considered",
      ],
      correct: "C"
    },
    {
      id: 60577,
      question: "What is the embedded (nested) strategy similar to?",
      options: [
        "Sequential design",
        "Triangulation strategy, but one part has more weight",
        "Single method research",
        "Case study design",
      ],
      correct: "B"
    },
    {
      id: 60578,
      question: "In the embedded strategy, which part has more weight?",
      options: [
        "Always quantitative",
        "Always qualitative",
        "Either quantitative or qualitative can have more weight",
        "Neither has any weight",
      ],
      correct: "C"
    },
    {
      id: 60579,
      question: "What is the purpose of the discussion section in a research paper?",
      options: [
        "To list all references",
        "To express interpretations and opinions, explain implications, and make suggestions for future research",
        "To describe the methodology only",
        "To present raw data",
      ],
      correct: "B"
    },
    {
      id: 60580,
      question: "What does the discussion section explain about the results?",
      options: [
        "How data was collected",
        "What the results mean and what contribution the paper makes to the field of study",
        "Who funded the research",
        "When the research was completed",
      ],
      correct: "B"
    },
    {
      id: 60581,
      question: "What does the discussion section confirm?",
      options: [
        "The budget",
        "The topic and the consistency with previous research",
        "The timeline",
        "The team members",
      ],
      correct: "B"
    },
    {
      id: 60582,
      question: "What should also be explained in the discussion section?",
      options: [
        "Only strengths",
        "Only weaknesses",
        "Weaknesses and strengths of the research",
        "Neither weaknesses nor strengths",
      ],
      correct: "C"
    },
    {
      id: 60583,
      question: "What is the purpose of the acknowledgement section?",
      options: [
        "To list all references",
        "To appreciate all those people who were supportive in performing the research",
        "To describe methodology",
        "To present findings",
      ],
      correct: "B"
    },
    {
      id: 60584,
      question: "How should people be included in the acknowledgement section?",
      options: [
        "In alphabetical order",
        "In the appropriate order according to the importance of their help",
        "In random order",
        "By age",
      ],
      correct: "B"
    },
    {
      id: 60585,
      question: "What should the appreciation in the acknowledgement section be like?",
      options: [
        "Long and detailed",
        "Brief, and expression should not be emotional",
        "Emotional and lengthy",
        "Only for financial supporters",
      ],
      correct: "B"
    },
    {
      id: 60586,
      question: "Why is it essential to cite all references in research papers?",
      options: [
        "To make the paper longer",
        "To acknowledge sources and make the paper reliable enough",
        "To impress reviewers",
        "To fill space",
      ],
      correct: "B"
    },
    {
      id: 60587,
      question: "When should we acknowledge a source?",
      options: [
        "Only when quoting directly",
        "Once we use an idea or a fact obtained from that specific source",
        "Only for books",
        "Only for recent publications",
      ],
      correct: "B"
    },
    {
      id: 60588,
      question: "What types of sources are citations related to?",
      options: [
        "Only textbooks",
        "Textbooks, journals, internet sites, e-mails, and even verbal conversations",
        "Only peer-reviewed journals",
        "Only government publications",
      ],
      correct: "B"
    },
    {
      id: 60589,
      question: "When citing a reference in-text using APA format, what should be mentioned?",
      options: [
        "The publisher name",
        "The author by last name followed by the year of publication",
        "The page count",
        "The ISBN number",
      ],
      correct: "B"
    },
    {
      id: 60590,
      question: "Which is a correct APA in-text citation format according to the document?",
      options: [
        "Williams, 2012, p. 45",
        "According to Williams (2012), or (Williams, 2012)",
        "Williams J. 2012",
        "[Williams 2012]",
      ],
      correct: "B"
    },
    {
      id: 60591,
      question: "For two authors in APA format, what format should be used?",
      options: [
        "Williams et al., 2015",
        "Scott and Hollis, 2015",
        "Scott/Hollis 2015",
        "S & H, 2015",
      ],
      correct: "B"
    },
    {
      id: 60592,
      question: "For three, four, or five authors, what should the first text citation include?",
      options: [
        "Only the first author",
        "All authors\' names such as Sharp, Aarons, Wittenberg, & Gittens, 2007",
        "Only the last author",
        "The institution name",
      ],
      correct: "B"
    },
    {
      id: 60593,
      question: "For three, four, or five authors, what format is used in subsequent text citations?",
      options: [
        "All authors\' names",
        "Sharp et al., 2007",
        "Only the first two authors",
        "The journal name",
      ],
      correct: "B"
    },
    {
      id: 60594,
      question: "For six or more authors, what is used in the first text citation?",
      options: [
        "All authors\' names",
        "Mendelsohn et al., 2010",
        "Only the first author",
        "The institution name",
      ],
      correct: "B"
    },
    {
      id: 60595,
      question: "For six or more authors, what is used in subsequent text citations?",
      options: [
        "All authors\' names",
        "Mendelsohn et al., 2010",
        "Only the last author",
        "Anonymous",
      ],
      correct: "B"
    },
    {
      id: 60596,
      question: "What format should be used for verbal communication sources?",
      options: [
        "Author name only",
        "Name, company/institution, and personal communication",
        "Date only",
        "Topic only",
      ],
      correct: "B"
    },
    {
      id: 60597,
      question: "Which is a correct format for citing verbal communication?",
      options: [
        "Richard Summerbell, 2020",
        "Richard Summerbell, Sporometrics Inc., personal communication",
        "Summerbell, R. personal",
        "Verbal source, 2020",
      ],
      correct: "B"
    },
    {
      id: 60598,
      question: "For internet sources in in-text citations, what should simply be used?",
      options: [
        "The website name",
        "The URL address",
        "The date accessed",
        "The author name only",
      ],
      correct: "B"
    },
    {
      id: 60599,
      question: "At the end of the paper using APA format, what must the list of references include?",
      options: [
        "Only books",
        "All the references used in the entire paper",
        "Only journal articles",
        "Only internet sources",
      ],
      correct: "C"
    },
    {
      id: 60600,
      question: "For books in APA format, what should be listed?",
      options: [
        "Only the title and author",
        "All authors by last name and initials, year, title, edition, publisher, city, and number of pages",
        "Only the ISBN",
        "Only the publication year",
      ],
      correct: "D"
    },
    {
      id: 60601,
      question: "Which is a correct APA book reference format?",
      options: [
        "Davies and Logan, Reading research, 2012",
        "Davies, B., and Logan, J. (2012). Reading research: A user-friendly guide for health professionals (5th ed.). Elsevier Inc. Toronto, Canada. 82 p.",
        "Reading research by Davies 2012",
        "Davies B Logan J 2012 Reading research",
      ],
      correct: "B"
    },
    {
      id: 60602,
      question: "For journal articles in APA format, what should be listed?",
      options: [
        "Only the journal name",
        "Authors by last name and initials, year, title of article, journal title, volume and issue numbers, and page numbers",
        "Only the article title",
        "Only the DOI",
      ],
      correct: "A"
    },
    {
      id: 60603,
      question: "What is included in an APA journal article reference?",
      options: [
        "Only the abstract",
        "Authors, year, article title, journal title, volume, issue, and page numbers",
        "Only the journal impact factor",
        "Only the keywords",
      ],
      correct: "B"
    },
    {
      id: 60604,
      question: "For internet sources in the reference list, what should follow the authors and year?",
      options: [
        "Only the URL",
        "Full title of the work and the full URL address following \"Retrieved from\"",
        "Only the date accessed",
        "Only the website name",
      ],
      correct: "A"
    },
    {
      id: 60605,
      question: "What phrase precedes the URL in APA internet source references?",
      options: [
        "Found at",
        "Retrieved from",
        "Available at",
        "Sourced from",
      ],
      correct: "B"
    },
    {
      id: 60606,
      question: "What does integration refer to in mixed methods research?",
      options: [
        "Combining research teams",
        "The point at which quantitative and qualitative phases are combined",
        "Integrating different software",
        "Combining funding sources",
      ],
      correct: "B"
    },
    {
      id: 60607,
      question: "What distinguishes explanatory from exploratory strategies?",
      options: [
        "The number of researchers",
        "The order of quantitative and qualitative data collection",
        "The sample size",
        "The funding amount",
      ],
      correct: "B"
    },
    {
      id: 60608,
      question: "Why might mixed methods be preferred over single methods in healthcare research?",
      options: [
        "It is cheaper",
        "It can provide more comprehensive answers about complex health issues",
        "It is faster",
        "It requires less expertise",
      ],
      correct: "B"
    },
    {
      id: 60609,
      question: "What role does prior knowledge play in mixed methods research?",
      options: [
        "It is not considered",
        "Research problems can become hypothesis and/or research questions based on it",
        "It must be ignored",
        "It only affects funding",
      ],
      correct: "B"
    },
    {
      id: 60610,
      question: "What makes concurrent design different from sequential design?",
      options: [
        "It uses fewer researchers",
        "Both sets of data are combined rather than kept separate",
        "It takes less time",
        "It costs less",
      ],
      correct: "B"
    },
    {
      id: 60611,
      question: "How does the embedded strategy differ from triangulation?",
      options: [
        "It uses different software",
        "One part (quantitative or qualitative) has more weight than the other",
        "It is faster",
        "It uses fewer participants",
      ],
      correct: "B"
    },
  ],
  "7. Essentials of Statistics (Part 1)": [
    {
      id: 60650,
      question: "The study of statistics is categorized into how many main branches?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60651,
      question: "What are the two main branches of statistics?",
      options: [
        "Primary and secondary statistics",
        "Descriptive and inferential statistics",
        "Simple and complex statistics",
        "Basic and advanced statistics",
      ],
      correct: "B"
    },
    {
      id: 60652,
      question: "Which branch of statistics is needed in expressing characteristics and/or summarizing data?",
      options: [
        "Inferential statistics",
        "Predictive statistics",
        "Descriptive statistics",
        "Analytical statistics",
      ],
      correct: "C"
    },
    {
      id: 60653,
      question: "How many main concepts are included in descriptive statistics?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six",
      ],
      correct: "C"
    },
    {
      id: 60654,
      question: "Which of the following is NOT a main concept of descriptive statistics?",
      options: [
        "Mean",
        "Median",
        "Correlation",
        "Standard deviation",
      ],
      correct: "C"
    },
    {
      id: 60655,
      question: "What are the five main concepts of descriptive statistics?",
      options: [
        "Mean, median, mode, range, and standard deviation",
        "Mean, variance, mode, range, and correlation",
        "Median, mode, range, variance, and regression",
        "Mean, median, frequency, range, and variance",
      ],
      correct: "A"
    },
    {
      id: 60656,
      question: "How is the arithmetic mean of a data set obtained?",
      options: [
        "By finding the middle value",
        "By adding up all the values and dividing by the number of values",
        "By finding the most frequent value",
        "By subtracting the smallest from the largest value",
      ],
      correct: "B"
    },
    {
      id: 60657,
      question: "What does the symbol x̄ represent in statistics?",
      options: [
        "The median",
        "The mode",
        "The arithmetic mean",
        "The range",
      ],
      correct: "C"
    },
    {
      id: 60658,
      question: "In the mean formula x̄ = Σx/n, what does n represent?",
      options: [
        "The sum of all values",
        "The number of values in the collection",
        "The largest value",
        "The smallest value",
      ],
      correct: "B"
    },
    {
      id: 60659,
      question: "In the mean formula, what does the symbol Σ represent?",
      options: [
        "Division",
        "Multiplication",
        "Sum",
        "Subtraction",
      ],
      correct: "C"
    },
    {
      id: 60660,
      question: "When calculating mean for grouped data, what must be determined for each group?",
      options: [
        "The range",
        "The midpoint",
        "The standard deviation",
        "The variance",
      ],
      correct: "B"
    },
    {
      id: 60661,
      question: "In grouped data, what is multiplied together to help calculate the mean?",
      options: [
        "Range and frequency",
        "Midpoint (x) and frequency (f)",
        "Mode and median",
        "Standard deviation and frequency",
      ],
      correct: "B"
    },
    {
      id: 60662,
      question: "What is the median?",
      options: [
        "The most frequent value in a data set",
        "The average of all values",
        "The middle value of an ordered set",
        "The difference between largest and smallest values",
      ],
      correct: "C"
    },
    {
      id: 60663,
      question: "The median divides ordered values into how many halves?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60664,
      question: "If the number of observations (n) is odd, how is the median calculated?",
      options: [
        "(n/2)th observation",
        "((n+1)/2)th observation in the ordered set",
        "(n-1)/2)th observation",
        "The first observation",
      ],
      correct: "B"
    },
    {
      id: 60665,
      question: "When n is even, the median is calculated using which observations?",
      options: [
        "Only the (n/2)th observation",
        "The (n/2)th observation and the ((n/2)+1)th observation, then divided by 2",
        "Only the first and last observations",
        "The sum of all observations divided by n",
      ],
      correct: "B"
    },
    {
      id: 60666,
      question: "What must be done to data before finding the median?",
      options: [
        "Calculate the mean first",
        "Order the values",
        "Find the mode",
        "Calculate the range",
      ],
      correct: "B"
    },
    {
      id: 60667,
      question: "What is the mode or modal value?",
      options: [
        "The middle value in a data set",
        "The average of all values",
        "The value in the data with the highest frequency",
        "The difference between extreme values",
      ],
      correct: "C"
    },
    {
      id: 60668,
      question: "In what sense is the mode considered a measure?",
      options: [
        "A measure of central tendency only",
        "A measure of common-ness or typical-ness",
        "A measure of variability",
        "A measure of spread",
      ],
      correct: "B"
    },
    {
      id: 60669,
      question: "What is true about some data sets regarding the mode?",
      options: [
        "All data sets have exactly one mode",
        "Some data sets do not have a mode, while some have more than one mode",
        "Every data set must have at least two modes",
        "The mode is always equal to the median",
      ],
      correct: "B"
    },
    {
      id: 60670,
      question: "What is a data set with two modes called?",
      options: [
        "Unimodal",
        "Bimodal",
        "Multimodal",
        "Amodal",
      ],
      correct: "B"
    },
    {
      id: 60671,
      question: "What is the range?",
      options: [
        "The average of all values",
        "The middle value of a data set",
        "The most frequent value",
        "The difference between the largest and smallest observations",
      ],
      correct: "D"
    },
    {
      id: 60672,
      question: "What does the range describe about a data collection?",
      options: [
        "The central tendency",
        "The variability and inconsistency",
        "The frequency distribution",
        "The typical value",
      ],
      correct: "B"
    },
    {
      id: 60673,
      question: "How is the range calculated?",
      options: [
        "Adding all values together",
        "Dividing the sum by the number of values",
        "Subtracting the smallest observation from the largest observation",
        "Finding the middle value",
      ],
      correct: "C"
    },
    {
      id: 60674,
      question: "What can the standard deviation (SD) be thought of as?",
      options: [
        "The middle value of data",
        "The most common value",
        "A measure of the average distance of data values from their collective mean",
        "The difference between extremes",
      ],
      correct: "C"
    },
    {
      id: 60675,
      question: "If data values are widely spread, what will the standard deviation be?",
      options: [
        "Small",
        "Zero",
        "Large",
        "Negative",
      ],
      correct: "C"
    },
    {
      id: 60676,
      question: "If data values are narrowly spread, what will the standard deviation be?",
      options: [
        "Large",
        "Small",
        "Negative",
        "Infinite",
      ],
      correct: "B"
    },
    {
      id: 60677,
      question: "In the standard deviation formula, what does (n-1) represent in the denominator?",
      options: [
        "The total number of observations",
        "One less than the number of observations (degrees of freedom)",
        "The sum of observations",
        "The mean value",
      ],
      correct: "B"
    },
    {
      id: 60678,
      question: "In the SD formula SD = √[Σ(x-x̄)²/(n-1)], what does x represent?",
      options: [
        "The mean",
        "The score of each observation",
        "The number of observations",
        "The standard deviation",
      ],
      correct: "B"
    },
    {
      id: 60679,
      question: "In the SD formula, what does x̄ represent?",
      options: [
        "Individual score",
        "Sample mean",
        "Population size",
        "Standard deviation",
      ],
      correct: "B"
    },
    {
      id: 60680,
      question: "What operation is performed on (x - x̄) before summing in the SD formula?",
      options: [
        "Taking the absolute value",
        "Squaring",
        "Taking the square root",
        "Dividing by n",
      ],
      correct: "B"
    },
    {
      id: 60681,
      question: "What is the final mathematical operation in calculating standard deviation?",
      options: [
        "Squaring the result",
        "Dividing by the mean",
        "Taking the square root",
        "Multiplying by n",
      ],
      correct: "C"
    },
    {
      id: 60682,
      question: "Given blood glucose values: 72, 80, 106, 119, 78, 62, 66, 65, 86, 100, 91, 70, 73, 66, 79, how many values are in this data set?",
      options: [
        "12",
        "13",
        "14",
        "15",
      ],
      correct: "D"
    },
    {
      id: 60683,
      question: "For the age group 20-29, what is the midpoint?",
      options: [
        "20",
        "24.5",
        "25",
        "29",
      ],
      correct: "B"
    },
    {
      id: 60684,
      question: "For the age group 40-49, what is the midpoint?",
      options: [
        "40",
        "44.5",
        "45",
        "49",
      ],
      correct: "B"
    },
    {
      id: 60685,
      question: "For the age group 60-69, what is the midpoint?",
      options: [
        "60",
        "64.5",
        "65",
        "69",
      ],
      correct: "B"
    },
    {
      id: 60686,
      question: "To find the mean for grouped data, what formula is used after calculating fx values?",
      options: [
        "Σf / Σx",
        "Σfx / Σf",
        "Σx / n",
        "Σf × Σx",
      ],
      correct: "B"
    },
    {
      id: 60687,
      question: "In the median formula for odd n, if there are 7 observations, which observation is the median?",
      options: [
        "The 3rd observation",
        "The 4th observation",
        "The 5th observation",
        "The 7th observation",
      ],
      correct: "B"
    },
    {
      id: 60688,
      question: "For the ages 30, 32, 33, 38, 42, 48, and 50, what is the median?",
      options: [
        "33",
        "35",
        "38",
        "40",
      ],
      correct: "C"
    },
    {
      id: 60689,
      question: "If systolic pressures are 110, 120, 120, 130, 130, 140, 160, 170 (ordered), how is the median found?",
      options: [
        "The 4th value",
        "The average of the 4th and 5th values",
        "The 5th value",
        "The average of all values",
      ],
      correct: "B"
    },
    {
      id: 60690,
      question: "In the Apgar scores: 0-3-4-3-8-7-5-7-9-5-3-5-6-1-8-5-8-8-8-0-8-5, which value appears most frequently?",
      options: [
        "3",
        "5",
        "8",
        "5 and 8 (bimodal)",
      ],
      correct: "D"
    },
    {
      id: 60691,
      question: "Based on the delivery method data showing Emergency Cesarean Section 9 times and Spontaneous vaginal delivery 8 times, which is the mode?",
      options: [
        "Spontaneous vaginal delivery",
        "Emergency Cesarean Section",
        "Vacuum-assisted vaginal delivery",
        "Forceps",
      ],
      correct: "B"
    },
    {
      id: 60692,
      question: "For birthweights: 2170, 2220, 2660, 2780, 2840, 3220, 3330, 3340, 3500, 3540, 3820, 4140, what is the range?",
      options: [
        "1920 g",
        "1970 g",
        "2000 g",
        "2170 g",
      ],
      correct: "B"
    },
    {
      id: 60693,
      question: "What is calculated first when determining standard deviation?",
      options: [
        "The range",
        "The median",
        "The mean",
        "The mode",
      ],
      correct: "C"
    },
    {
      id: 60694,
      question: "After finding the mean, what is the next step in calculating standard deviation?",
      options: [
        "Find the range",
        "Subtract the mean from each observation (x - x̄)",
        "Add all values together",
        "Find the median",
      ],
      correct: "B"
    },
    {
      id: 60695,
      question: "After calculating (x - x̄) for each value, what is done next?",
      options: [
        "Add them together",
        "Square each difference",
        "Take the square root",
        "Divide by n",
      ],
      correct: "B"
    },
    {
      id: 60696,
      question: "What happens after squaring all the (x - x̄) values?",
      options: [
        "Take the square root",
        "Sum all the squared differences",
        "Divide by the mean",
        "Multiply by n",
      ],
      correct: "B"
    },
    {
      id: 60697,
      question: "After summing the squared differences, what is done before taking the square root?",
      options: [
        "Multiply by n",
        "Add the mean",
        "Divide by (n-1)",
        "Divide by n",
      ],
      correct: "C"
    },
    {
      id: 60698,
      question: "For diastolic blood pressure values 100, 60, 80, 70, 110, what is the mean?",
      options: [
        "80 mmHg",
        "84 mmHg",
        "90 mmHg",
        "100 mmHg",
      ],
      correct: "B"
    },
    {
      id: 60699,
      question: "For LDL cholesterol values 110, 130, 160, 140, 190, 170, how many observations are there?",
      options: [
        "4",
        "5",
        "6",
        "7",
      ],
      correct: "C"
    },
    {
      id: 60700,
      question: "For heart rate values 120, 110, 105, 110 in tachycardia patients, what is the mean?",
      options: [
        "105 bpm",
        "110 bpm",
        "111.25 bpm",
        "115 bpm",
      ],
      correct: "C"
    },
    {
      id: 60701,
      question: "For hematocrit values 39, 47, 43, 44, 40, what is the sum?",
      options: [
        "210",
        "213",
        "215",
        "220",
      ],
      correct: "B"
    },
    {
      id: 60702,
      question: "Which measure of central tendency is most affected by extreme values (outliers)?",
      options: [
        "Mean",
        "Median",
        "Mode",
        "Range",
      ],
      correct: "A"
    },
    {
      id: 60703,
      question: "Which measure of central tendency is best for skewed data?",
      options: [
        "Mean",
        "Median",
        "Mode",
        "Standard deviation",
      ],
      correct: "B"
    },
    {
      id: 60704,
      question: "What type of variable is typically analyzed using mean, median, and mode?",
      options: [
        "Nominal variables only",
        "Ordinal variables only",
        "Quantitative (numerical) variables",
        "Categorical variables only",
      ],
      correct: "C"
    },
    {
      id: 60705,
      question: "In calculating the mean for grouped data with age groups, which column represents the number of people in each age group?",
      options: [
        "Midpoint (x)",
        "Frequency (f)",
        "fx",
        "Age Groups",
      ],
      correct: "B"
    },
    {
      id: 60706,
      question: "When there are 15 blood glucose observations, which formula position gives the median?",
      options: [
        "7th observation",
        "8th observation",
        "7.5th observation",
        "15th observation",
      ],
      correct: "B"
    },
    {
      id: 60707,
      question: "If a data set has values 2, 3, 3, 4, 5, 5, 5, 6, what is the mode?",
      options: [
        "2",
        "3",
        "5",
        "6",
      ],
      correct: "C"
    },
    {
      id: 60708,
      question: "Why is (n-1) used instead of n in the sample standard deviation formula?",
      options: [
        "To make the calculation simpler",
        "To provide a better estimate of population standard deviation",
        "To reduce the final value",
        "To eliminate outliers",
      ],
      correct: "B"
    },
    {
      id: 60709,
      question: "Which descriptive statistic describes the spread or dispersion of data?",
      options: [
        "Mean",
        "Median",
        "Mode",
        "Standard deviation",
      ],
      correct: "D"
    },
    {
      id: 60710,
      question: "For weight loss groups 1-2, 3-5, 6-8, 9-12 kg, which group has the highest frequency of 32?",
      options: [
        "1-2 kg",
        "3-5 kg",
        "6-8 kg",
        "9-12 kg",
      ],
      correct: "A"
    },
    {
      id: 60711,
      question: "In the weight loss data, which group has a frequency of 5?",
      options: [
        "1-2 kg",
        "3-5 kg",
        "6-8 kg",
        "9-12 kg",
      ],
      correct: "D"
    },
    {
      id: 60712,
      question: "What is the total frequency in the weight loss example (32 + 18 + 11 + 5)?",
      options: [
        "56",
        "66",
        "76",
        "86",
      ],
      correct: "B"
    },
    {
      id: 60713,
      question: "When comparing ICU mortality percentages, which statistic would show the typical mortality rate?",
      options: [
        "Range",
        "Mean or median",
        "Standard deviation",
        "Frequency",
      ],
      correct: "B"
    },
    {
      id: 60714,
      question: "In the ICU data with 26 values, the median would be the average of which observations?",
      options: [
        "12th and 13th",
        "13th and 14th",
        "14th and 15th",
        "26th only",
      ],
      correct: "B"
    },
    {
      id: 60715,
      question: "Which measure is NOT affected by extreme values in a data set?",
      options: [
        "Mean",
        "Range",
        "Median",
        "Standard deviation",
      ],
      correct: "C"
    },
    {
      id: 60716,
      question: "For the birthweight data, what is the smallest value?",
      options: [
        "2170 g",
        "2220 g",
        "2660 g",
        "2780 g",
      ],
      correct: "A"
    },
    {
      id: 60717,
      question: "For the birthweight data, what is the largest value?",
      options: [
        "3820 g",
        "3540 g",
        "4000 g",
        "4140 g",
      ],
      correct: "D"
    },
  ],
  "8. Essentials of Statistics (Part 2)": [
    {
      id: 60800,
      question: "How many main concepts are included in inferential statistics?",
      options: [
        "Five",
        "Seven",
        "Nine",
        "Eleven",
      ],
      correct: "C"
    },
    {
      id: 60801,
      question: "Which of the following is NOT a main concept of inferential statistics?",
      options: [
        "t-test",
        "Mean",
        "chi-square test",
        "Correlation",
      ],
      correct: "B"
    },
    {
      id: 60802,
      question: "Which of the following IS a main concept of inferential statistics?",
      options: [
        "Mode",
        "Median",
        "Range",
        "Confidence interval",
      ],
      correct: "D"
    },
    {
      id: 60803,
      question: "In healthcare, what two types of significance must be distinguished?",
      options: [
        "Primary and secondary significance",
        "Clinical and statistical significance",
        "Major and minor significance",
        "Direct and indirect significance",
      ],
      correct: "B"
    },
    {
      id: 60804,
      question: "When is an observation considered statistically significant?",
      options: [
        "When the sample size is large",
        "When the difference between groups is unlikely a result of chance alone",
        "When the results are clinically important",
        "When multiple tests are performed",
      ],
      correct: "B"
    },
    {
      id: 60805,
      question: "What is of great importance in determining statistical significance?",
      options: [
        "Sample size",
        "Number of groups",
        "p value",
        "Effect size",
      ],
      correct: "C"
    },
    {
      id: 60806,
      question: "What does the null hypothesis assume?",
      options: [
        "A large effect in the population",
        "No effect in the population",
        "A positive correlation",
        "A negative correlation",
      ],
      correct: "B"
    },
    {
      id: 60807,
      question: "How is the null hypothesis typically symbolized?",
      options: [
        "H1",
        "Ha",
        "H0",
        "Hn",
      ],
      correct: "C"
    },
    {
      id: 60808,
      question: "In comparing MI rates between men and women, what would the null hypothesis state?",
      options: [
        "MI rates are higher in men",
        "MI rates are higher in women",
        "MI rates are the same among men and women in the population",
        "MI rates cannot be compared",
      ],
      correct: "C"
    },
    {
      id: 60809,
      question: "What does the alternative hypothesis state?",
      options: [
        "That there is no effect",
        "That a specific parameter is different from the value in the null hypothesis",
        "That the sample size is adequate",
        "That the study should be repeated",
      ],
      correct: "B"
    },
    {
      id: 60810,
      question: "How is the alternative hypothesis symbolized?",
      options: [
        "H0",
        "H1",
        "Hn",
        "Ha (both B and D are acceptable, but document shows H1)",
      ],
      correct: "B"
    },
    {
      id: 60811,
      question: "What do all hypothesis tests ultimately use to weigh the strength of evidence?",
      options: [
        "Sample size",
        "Effect size",
        "p-value",
        "Confidence interval",
      ],
      correct: "C"
    },
    {
      id: 60812,
      question: "What does a small p-value (typically < 0.05) indicate?",
      options: [
        "Weak evidence against the null hypothesis",
        "Strong evidence against the null hypothesis",
        "No evidence against the null hypothesis",
        "The study should be repeated",
      ],
      correct: "B"
    },
    {
      id: 60813,
      question: "When p < 0.05, what action is taken regarding the null hypothesis?",
      options: [
        "Accept the null hypothesis",
        "Reject the null hypothesis",
        "Ignore the null hypothesis",
        "Modify the null hypothesis",
      ],
      correct: "B"
    },
    {
      id: 60814,
      question: "What does p < 0.05 mean in terms of probability?",
      options: [
        "There is a 50% probability that results are due to chance",
        "There is a 5% or less probability that results are due to chance alone",
        "There is a 95% probability that results are due to chance",
        "There is no probability calculation possible",
      ],
      correct: "B"
    },
    {
      id: 60815,
      question: "What does a large p-value (≥ 0.05) indicate?",
      options: [
        "Strong evidence against the null hypothesis",
        "Weak evidence against the null hypothesis",
        "The alternative hypothesis is true",
        "The study was poorly designed",
      ],
      correct: "B"
    },
    {
      id: 60816,
      question: "When p ≥ 0.05, what happens to the null hypothesis?",
      options: [
        "We reject the null hypothesis",
        "We accept the alternative hypothesis",
        "We fail to reject the null hypothesis",
        "We modify both hypotheses",
      ],
      correct: "C"
    },
    {
      id: 60817,
      question: "How is p-value usually determined?",
      options: [
        "By hand calculation",
        "By a computer",
        "By estimation",
        "By the researcher\'s judgment",
      ],
      correct: "B"
    },
    {
      id: 60818,
      question: "What is clinical significance also called?",
      options: [
        "Statistical importance",
        "Clinical importance",
        "Research significance",
        "Practical value",
      ],
      correct: "B"
    },
    {
      id: 60819,
      question: "What is a t-test used to analyze?",
      options: [
        "The difference between two mean scores",
        "The difference between three or more means",
        "The correlation between variables",
        "The frequency distribution",
      ],
      correct: "A"
    },
    {
      id: 60820,
      question: "A t-test is used to compare how many different sets of values?",
      options: [
        "One",
        "Two",
        "Three",
        "Four or more",
      ],
      correct: "B"
    },
    {
      id: 60821,
      question: "What does ANOVA stand for?",
      options: [
        "Analysis of Numerical Outcomes and Variables Assessment",
        "Analysis of Variance",
        "Alternative Null Outcome Variance Analysis",
        "Assessment of Numerical and Ordinal Variables Analysis",
      ],
      correct: "B"
    },
    {
      id: 60822,
      question: "ANOVA is used to analyze mean score differences between how many groups?",
      options: [
        "Two groups only",
        "Three or more groups",
        "One group only",
        "Exactly four groups",
      ],
      correct: "B"
    },
    {
      id: 60823,
      question: "In the cholesterol level example, how many weight categories were compared using ANOVA?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 60824,
      question: "What were the four weight categories in the ANOVA cholesterol example?",
      options: [
        "Thin, average, heavy, very heavy",
        "Underweight, overweight, obese, and normal weight",
        "Low, medium, high, very high",
        "Small, medium, large, extra large",
      ],
      correct: "B"
    },
    {
      id: 60825,
      question: "ANOVA separates total variability into how many components?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60826,
      question: "What are the two components of variability in ANOVA?",
      options: [
        "Primary and secondary variation",
        "Between-group and within-group variation",
        "Positive and negative variation",
        "Large and small variation",
      ],
      correct: "B"
    },
    {
      id: 60827,
      question: "Under the null hypothesis in ANOVA, how do between-group and within-group variations compare?",
      options: [
        "Between-group is much larger",
        "Within-group is much larger",
        "They are similar",
        "They cannot be compared",
      ],
      correct: "C"
    },
    {
      id: 60828,
      question: "In ANOVA, what do we expect when there is a true difference between groups?",
      options: [
        "Smaller between-group variation",
        "Larger between-group variation",
        "Equal variations",
        "No variation at all",
      ],
      correct: "B"
    },
    {
      id: 60829,
      question: "Which test is described as the most important and most common method in statistical analysis?",
      options: [
        "t-test",
        "ANOVA",
        "chi-square test",
        "Correlation test",
      ],
      correct: "C"
    },
    {
      id: 60830,
      question: "What is the purpose of the chi-square test?",
      options: [
        "To compare two means",
        "To determine the difference between observed frequency and expected frequency",
        "To measure correlation",
        "To calculate effect size",
      ],
      correct: "B"
    },
    {
      id: 60831,
      question: "What is correlation?",
      options: [
        "The difference between two means",
        "The relationship between two variables",
        "The frequency of an event",
        "The effect size of a treatment",
      ],
      correct: "B"
    },
    {
      id: 60832,
      question: "Correlation indicates the statistical dependence between how many random variables?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60833,
      question: "What is a correlation coefficient helpful in verifying?",
      options: [
        "Sample size adequacy",
        "A relationship between actual and predicted values",
        "The null hypothesis",
        "Clinical significance",
      ],
      correct: "B"
    },
    {
      id: 60834,
      question: "According to conventional guidelines, what correlation coefficient (r) is considered low?",
      options: [
        "0.1",
        "0.3",
        "0.5",
        "0.8",
      ],
      correct: "B"
    },
    {
      id: 60835,
      question: "According to conventional guidelines, what correlation coefficient (r) is considered medium?",
      options: [
        "0.1",
        "0.3",
        "0.5",
        "0.8",
      ],
      correct: "C"
    },
    {
      id: 60836,
      question: "According to conventional guidelines, what correlation coefficient (r) is considered high?",
      options: [
        "0.3",
        "0.5",
        "0.7",
        "0.8",
      ],
      correct: "D"
    },
    {
      id: 60837,
      question: "How many types of correlations are there?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "C"
    },
    {
      id: 60838,
      question: "What are the three types of correlations?",
      options: [
        "High, medium, and low correlation",
        "Positive, negative, and no correlation",
        "Strong, weak, and moderate correlation",
        "Direct, indirect, and partial correlation",
      ],
      correct: "B"
    },
    {
      id: 60839,
      question: "In positive correlation, what happens when values of one variable increase?",
      options: [
        "Values of another variable decrease",
        "Values of another variable increase",
        "Values of another variable stay the same",
        "There is no effect on another variable",
      ],
      correct: "B"
    },
    {
      id: 60840,
      question: "In negative correlation, what happens when values of one variable increase?",
      options: [
        "Values of another variable also increase",
        "Values of another variable decrease",
        "Values of another variable stay the same",
        "There is no predictable pattern",
      ],
      correct: "B"
    },
    {
      id: 60841,
      question: "What characterizes no correlation?",
      options: [
        "Both variables increase together",
        "Both variables decrease together",
        "There is no impact on one variable with changes in another",
        "Variables are inversely related",
      ],
      correct: "C"
    },
    {
      id: 60842,
      question: "What is effect size?",
      options: [
        "The sample size needed for a study",
        "The strength of a relationship between two different variables",
        "The p-value of a study",
        "The confidence interval width",
      ],
      correct: "B"
    },
    {
      id: 60843,
      question: "Effect size measures the magnitude of what?",
      options: [
        "Sample size",
        "Treatment effect",
        "p-value",
        "Confidence interval",
      ],
      correct: "B"
    },
    {
      id: 60844,
      question: "When there is a small impact, what is needed to verify if an intervention makes a difference?",
      options: [
        "Smaller sample sizes",
        "Larger sample sizes",
        "Shorter study duration",
        "Fewer variables",
      ],
      correct: "B"
    },
    {
      id: 60845,
      question: "What is meta-analysis?",
      options: [
        "A type of qualitative research",
        "A statistical technique for combining results of several independent research studies",
        "A single randomized controlled trial",
        "A correlation analysis",
      ],
      correct: "B"
    },
    {
      id: 60846,
      question: "Meta-analysis typically combines results from what type of studies?",
      options: [
        "Case studies",
        "Qualitative interviews",
        "Usually RCTs (randomized controlled trials)",
        "Observational studies only",
      ],
      correct: "C"
    },
    {
      id: 60847,
      question: "Meta-analysis is most often used to assess what?",
      options: [
        "Sample size requirements",
        "The clinical effectiveness of healthcare interventions",
        "Correlation coefficients",
        "Effect sizes only",
      ],
      correct: "B"
    },
    {
      id: 60848,
      question: "What does NNT stand for?",
      options: [
        "Negative Null Test",
        "Number Needed to Treat",
        "Non-Normal Treatment",
        "Numerical Null Theory",
      ],
      correct: "B"
    },
    {
      id: 60849,
      question: "In the antibiotic example, if 40 hospitalized patients need to be treated before one unfavorable incident is prevented, what is the NNT?",
      options: [
        "1",
        "20",
        "40",
        "80",
      ],
      correct: "C"
    },
    {
      id: 60850,
      question: "Which statistical test would you use to compare the mean blood pressure of two groups?",
      options: [
        "chi-square test",
        "t-test",
        "ANOVA",
        "Correlation analysis",
      ],
      correct: "B"
    },
    {
      id: 60851,
      question: "Which statistical test would you use to compare the mean scores of four different treatment groups?",
      options: [
        "t-test",
        "chi-square test",
        "ANOVA",
        "Regression analysis",
      ],
      correct: "C"
    },
    {
      id: 60852,
      question: "Which test is used to analyze categorical data and observed vs expected frequencies?",
      options: [
        "t-test",
        "ANOVA",
        "Correlation",
        "chi-square test",
      ],
      correct: "D"
    },
    {
      id: 60853,
      question: "If r = 0.85, what would this correlation be classified as?",
      options: [
        "Low",
        "Medium",
        "High",
        "No correlation",
      ],
      correct: "C"
    },
    {
      id: 60854,
      question: "If r = 0.32, what would this correlation be classified as?",
      options: [
        "Low",
        "Medium",
        "High",
        "No correlation",
      ],
      correct: "A"
    },
    {
      id: 60855,
      question: "If r = 0.55, what would this correlation be classified as?",
      options: [
        "Low",
        "Medium",
        "High",
        "No correlation",
      ],
      correct: "B"
    },
    {
      id: 60856,
      question: "Which of the following is a concept of inferential statistics?",
      options: [
        "Standard deviation",
        "Regression analysis",
        "Mode",
        "Range",
      ],
      correct: "B"
    },
    {
      id: 60857,
      question: "What must researchers distinguish between in healthcare research?",
      options: [
        "Primary and secondary outcomes",
        "Clinical and statistical significance",
        "Large and small samples",
        "Qualitative and quantitative data",
      ],
      correct: "B"
    },
    {
      id: 60858,
      question: "Which analysis would be appropriate for comparing cholesterol levels across underweight, normal, overweight, and obese individuals?",
      options: [
        "t-test",
        "chi-square test",
        "ANOVA",
        "Correlation",
      ],
      correct: "C"
    },
    {
      id: 60859,
      question: "Confidence interval is a concept belonging to which branch of statistics?",
      options: [
        "Descriptive statistics",
        "Inferential statistics",
        "Both descriptive and inferential",
        "Neither branch",
      ],
      correct: "B"
    },
    {
      id: 60860,
      question: "The threshold p < 0.05 means results have what maximum percentage probability of being due to chance?",
      options: [
        "1%",
        "5%",
        "10%",
        "50%",
      ],
      correct: "B"
    },
  ],
  "9. Developing Research Questions and Hypothesis": [
    {
      id: 60900,
      question: "A research question is a concise, interrogative statement written in what tense?",
      options: [
        "Past tense",
        "Present tense",
        "Future tense",
        "Past perfect tense",
      ],
      correct: "B"
    },
    {
      id: 60901,
      question: "A research question must include how many or more variables/concepts?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 60902,
      question: "Which of the following is NOT a focus of research questions?",
      options: [
        "Describing variables",
        "Specifying the population being studied",
        "Determining the budget for the study",
        "Examining testable relationships among variables",
      ],
      correct: "C"
    },
    {
      id: 60903,
      question: "What should research questions define first in the development process?",
      options: [
        "The budget",
        "Specific topic area",
        "The timeline",
        "The research team",
      ],
      correct: "B"
    },
    {
      id: 60904,
      question: "Research questions should review what type of literature?",
      options: [
        "Popular literature",
        "Relevant literature",
        "Historical literature only",
        "Fiction literature",
      ],
      correct: "B"
    },
    {
      id: 60905,
      question: "When does the significance of the research question become apparent?",
      options: [
        "Before the study begins",
        "As the literature is critiqued",
        "After data collection",
        "During hypothesis testing",
      ],
      correct: "B"
    },
    {
      id: 60906,
      question: "What is a variable?",
      options: [
        "A constant value in research",
        "An attribute or property in which organisms vary",
        "A fixed measurement",
        "A predetermined outcome",
      ],
      correct: "B"
    },
    {
      id: 60907,
      question: "Variables can apply to which of the following?",
      options: [
        "People only",
        "Events only",
        "Objects only",
        "People, events, and objects",
      ],
      correct: "D"
    },
    {
      id: 60908,
      question: "The independent variable is also known as what factor?",
      options: [
        "Y Factor",
        "X Factor",
        "Z Factor",
        "W Factor",
      ],
      correct: "B"
    },
    {
      id: 60909,
      question: "What is the independent variable (IV)?",
      options: [
        "The presumed effect that varies with change",
        "The variable that has the presumed effect on the dependent variable",
        "The outcome measure",
        "The control variable",
      ],
      correct: "B"
    },
    {
      id: 60910,
      question: "The dependent variable is also known as what factor?",
      options: [
        "X Factor",
        "W Factor",
        "Y Factor",
        "Z Factor",
      ],
      correct: "C"
    },
    {
      id: 60911,
      question: "What is the dependent variable (DV)?",
      options: [
        "The variable that causes the effect",
        "The presumed effect that varies with a change in the independent variable",
        "The manipulated variable",
        "The control variable",
      ],
      correct: "B"
    },
    {
      id: 60912,
      question: "The question \"Is X related to Y?\" represents what type of research inquiry?",
      options: [
        "Descriptive inquiry",
        "Relationship inquiry between variables",
        "Historical inquiry",
        "Ethical inquiry",
      ],
      correct: "B"
    },
    {
      id: 60913,
      question: "What is the population in research?",
      options: [
        "A randomly selected group",
        "A well-defined set that has certain properties",
        "Only human subjects",
        "The sample size",
      ],
      correct: "B"
    },
    {
      id: 60914,
      question: "What is PICO?",
      options: [
        "A statistical test",
        "A framework for asking appropriate research questions",
        "A type of research design",
        "A sampling method",
      ],
      correct: "B"
    },
    {
      id: 60915,
      question: "How many different parts does a feasible PICO question include?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 60916,
      question: "What does P stand for in PICO?",
      options: [
        "Procedure",
        "Patient or population problem",
        "Protocol",
        "Probability",
      ],
      correct: "B"
    },
    {
      id: 60917,
      question: "What does I stand for in PICO?",
      options: [
        "Information",
        "Intervention",
        "Investigation",
        "Interpretation",
      ],
      correct: "B"
    },
    {
      id: 60918,
      question: "What does C stand for in PICO?",
      options: [
        "Conclusion",
        "Calculation",
        "Comparison",
        "Correlation",
      ],
      correct: "C"
    },
    {
      id: 60919,
      question: "What does O stand for in PICO?",
      options: [
        "Observation",
        "Operation",
        "Outcome",
        "Organization",
      ],
      correct: "C"
    },
    {
      id: 60920,
      question: "In the P section of PICO, what is necessary to describe?",
      options: [
        "The intervention method",
        "A person or group of people with a similar problem",
        "The expected outcome",
        "The comparison group",
      ],
      correct: "B"
    },
    {
      id: 60921,
      question: "Which characteristics should be defined in the P section of PICO?",
      options: [
        "Main complaint, health status, sex, age, race, and current medications",
        "Only the diagnosis",
        "Only the age and sex",
        "Only the medical history",
      ],
      correct: "A"
    },
    {
      id: 60922,
      question: "What does intervention refer to in PICO?",
      options: [
        "The patient\'s problem",
        "What has to be done for the patient",
        "The control group",
        "The expected result",
      ],
      correct: "B"
    },
    {
      id: 60923,
      question: "Which of the following is NOT a type of intervention mentioned?",
      options: [
        "Therapeutic",
        "Preventive",
        "Diagnostic",
        "Educational",
      ],
      correct: "D"
    },
    {
      id: 60924,
      question: "Which step in PICO is the only optional component?",
      options: [
        "Patient/Population",
        "Intervention",
        "Comparison",
        "Outcome",
      ],
      correct: "C"
    },
    {
      id: 60925,
      question: "Why might comparison be needed in PICO?",
      options: [
        "To determine the patient population",
        "To compare different alternatives for an intervention to choose the best one",
        "To measure the outcome",
        "To define the problem",
      ],
      correct: "B"
    },
    {
      id: 60926,
      question: "What does the outcome in PICO specify?",
      options: [
        "The patient population",
        "The intervention method",
        "The result(s) of what we plan to accomplish or improve",
        "The comparison group",
      ],
      correct: "C"
    },
    {
      id: 60927,
      question: "What is the study purpose?",
      options: [
        "The statistical analysis method",
        "The aim or goal the researcher hopes to achieve",
        "The sampling technique",
        "The data collection method",
      ],
      correct: "B"
    },
    {
      id: 60928,
      question: "The study purpose suggests what?",
      options: [
        "The sample size",
        "The type of design to be used",
        "The funding amount",
        "The publication venue",
      ],
      correct: "B"
    },
    {
      id: 60929,
      question: "What is a hypothesis?",
      options: [
        "A research question",
        "A formal statement of the expected relationship(s) between two or more variables in a specified population",
        "A literature review summary",
        "A data collection method",
      ],
      correct: "B"
    },
    {
      id: 60930,
      question: "When wording a hypothesis, what must be included?",
      options: [
        "Variables to be tested",
        "Budget requirements",
        "Researcher qualifications",
        "Publication goals",
      ],
      correct: "A"
    },
    {
      id: 60931,
      question: "Which of the following should be included when wording a hypothesis?",
      options: [
        "Population to be studied",
        "Funding sources",
        "Research team members",
        "Publication timeline",
      ],
      correct: "A"
    },
    {
      id: 60932,
      question: "What is testability in research?",
      options: [
        "The ability to fund a study",
        "The variables must lend themselves to observation, measurement, and analysis",
        "The ability to publish results",
        "The ability to recruit participants",
      ],
      correct: "B"
    },
    {
      id: 60933,
      question: "Which of the following is NOT a factor in feasibility?",
      options: [
        "Time",
        "Money",
        "Popularity",
        "Expertise",
      ],
      correct: "C"
    },
    {
      id: 60934,
      question: "Which of the following IS a factor in feasibility?",
      options: [
        "Access to subjects",
        "Researcher\'s age",
        "Journal impact factor",
        "Weather conditions",
      ],
      correct: "A"
    },
    {
      id: 60935,
      question: "What is a causal relationship?",
      options: [
        "A relationship with no effect",
        "A cause-and-effect interaction between two variables",
        "A random association",
        "An unclear connection",
      ],
      correct: "B"
    },
    {
      id: 60936,
      question: "\"Fatty liver causes liver cirrhosis\" is an example of what type of relationship?",
      options: [
        "Associative relationship",
        "Simple relationship",
        "Causal relationship",
        "Complex relationship",
      ],
      correct: "C"
    },
    {
      id: 60937,
      question: "What is an associative relationship?",
      options: [
        "A cause-and-effect relationship",
        "A relationship among variables that exist together in the real world",
        "A relationship with no connection",
        "A random association",
      ],
      correct: "B"
    },
    {
      id: 60938,
      question: "What is a simple relationship?",
      options: [
        "A relationship between three variables",
        "A relationship between two variables",
        "A relationship between four or more variables",
        "No relationship between variables",
      ],
      correct: "B"
    },
    {
      id: 60939,
      question: "\"Smoking leads to cancer\" is an example of what type of relationship?",
      options: [
        "Complex relationship",
        "Associative relationship",
        "Simple relationship",
        "No relationship",
      ],
      correct: "C"
    },
    {
      id: 60940,
      question: "What is a complex relationship?",
      options: [
        "A relationship between two variables",
        "A relationship between three or more variables",
        "A relationship between one variable",
        "No relationship",
      ],
      correct: "B"
    },
    {
      id: 60941,
      question: "What does a directional hypothesis state?",
      options: [
        "That no relationship exists",
        "Which way the relationship should exist",
        "That the relationship exists but not the direction",
        "That the variables are unrelated",
      ],
      correct: "B"
    },
    {
      id: 60942,
      question: "What does a nondirectional hypothesis state?",
      options: [
        "Which way the relationship exists",
        "That the relationship exists, but not the direction",
        "That no relationship exists",
        "The exact magnitude of the effect",
      ],
      correct: "B"
    },
    {
      id: 60943,
      question: "According to the flowchart, what should be examined first when developing a hypothesis?",
      options: [
        "The sample size",
        "The literature review and theoretical framework",
        "The budget",
        "The data collection method",
      ],
      correct: "B"
    },
    {
      id: 60944,
      question: "If the primary purpose is exploratory, descriptive, or hypothesis generating, what should be formulated?",
      options: [
        "Hypothesis",
        "Research question(s)",
        "Statistical analysis",
        "Sample size",
      ],
      correct: "B"
    },
    {
      id: 60945,
      question: "If the primary purpose is testing causal or associative relationships, what types of hypotheses may be formulated?",
      options: [
        "Only null hypotheses",
        "Research/scientific hypotheses or statistical/null hypotheses",
        "Only descriptive hypotheses",
        "Only exploratory hypotheses",
      ],
      correct: "B"
    },
    {
      id: 60946,
      question: "When critiquing hypotheses, what should be evaluated in the wording?",
      options: [
        "Clarity of statement",
        "Budget implications",
        "Team qualifications",
        "Publication potential",
      ],
      correct: "A"
    },
    {
      id: 60947,
      question: "When critiquing hypotheses, implications for what should be evaluated?",
      options: [
        "Funding",
        "Testability",
        "Publication",
        "Popularity",
      ],
      correct: "B"
    },
    {
      id: 60948,
      question: "When critiquing hypotheses, congruence with what should be evaluated?",
      options: [
        "Budget",
        "Timeline",
        "Theory",
        "Team goals",
      ],
      correct: "C"
    },
    {
      id: 60949,
      question: "When critiquing hypotheses, appropriateness for what should be evaluated?",
      options: [
        "Funding agency",
        "Research design used",
        "Publication journal",
        "Research team",
      ],
      correct: "B"
    },
    {
      id: 60950,
      question: "In the hypothesis example about caregivers of preterm infants, what was being compared?",
      options: [
        "Different hospitals",
        "Infants on versus not on apnea monitors",
        "Different medications",
        "Different nurses",
      ],
      correct: "B"
    },
    {
      id: 60951,
      question: "In the hypothesis example about menopausal hot flashes, what conditions were compared?",
      options: [
        "Different medications",
        "Fasting and experimentally sustained blood glucose concentrations",
        "Different exercise levels",
        "Different age groups",
      ],
      correct: "B"
    },
    {
      id: 60952,
      question: "In the Z-track injection hypothesis, what was predicted to be less?",
      options: [
        "Medication effectiveness",
        "Incidence and degree of severity of subject discomfort",
        "Number of injections needed",
        "Cost of treatment",
      ],
      correct: "B"
    },
  ],
  "10. Evidence-Informed Practice and Literature Review": [
    {
      id: 61000,
      question: "What is the term for the communication of research findings to others?",
      options: [
        "Dissemination",
        "Research utilization",
        "Evidence synthesis",
        "Knowledge creep",
      ],
      correct: "A"
    },
    {
      id: 61001,
      question: "Which of the following is NOT a mode of dissemination?",
      options: [
        "Publications",
        "Randomization",
        "Conferences",
        "Training programs",
      ],
      correct: "B"
    },
    {
      id: 61002,
      question: "Who pioneered the act of applying evidence to practice in the 1800s?",
      options: [
        "Clara Barton",
        "Virginia Henderson",
        "Florence Nightingale",
        "Dorothea Orem",
      ],
      correct: "C"
    },
    {
      id: 61003,
      question: "What type of evidence influences a researcher\'s thinking but not the action?",
      options: [
        "Decision-driven evidence",
        "Action-based evidence",
        "Practice-driven evidence",
        "Conceptually-driven evidence",
      ],
      correct: "D"
    },
    {
      id: 61004,
      question: "What may conceptually-driven evidence lead to?",
      options: [
        "An integrative review of the literature",
        "Immediate policy changes",
        "Direct patient care modifications",
        "Budget allocations",
      ],
      correct: "A"
    },
    {
      id: 61005,
      question: "What is decision-driven evidence?",
      options: [
        "Evidence that only affects theoretical frameworks",
        "Knowledge that remains unused in practice",
        "Application of scientific knowledge as part of a new practice, policy, procedure, or intervention",
        "Evidence used solely for academic purposes",
      ],
      correct: "C"
    },
    {
      id: 61006,
      question: "Which model is given as an example of decision-driven evidence application?",
      options: [
        "Rogers\' diffusion model",
        "CURN model",
        "RNABC model",
        "Iowa Model of Evidence-Based Practice to Promote Quality Care",
      ],
      correct: "D"
    },
    {
      id: 61007,
      question: "Evidence-Informed Practice (EIP) involves integrating which two elements to guide decision making?",
      options: [
        "Individual clinical expertise and the best external evidence",
        "Budget constraints and patient preferences",
        "Administrative policies and staff opinions",
        "Historical practices and intuition",
      ],
      correct: "A"
    },
    {
      id: 61008,
      question: "What does EIP use evidence to identify?",
      options: [
        "Only the benefits of interventions",
        "The potential harms and benefits, and costs of any intervention",
        "Only the costs of interventions",
        "Only the harms of interventions",
      ],
      correct: "B"
    },
    {
      id: 61009,
      question: "Why should adoption of practices be systematically promoted in an organization?",
      options: [
        "To reduce costs",
        "To satisfy regulatory requirements only",
        "To ensure consistency in application and care",
        "To increase staff workload",
      ],
      correct: "C"
    },
    {
      id: 61010,
      question: "What could arise if researchers decided individually what evidence to use in practice?",
      options: [
        "Improved patient outcomes",
        "Better communication",
        "Faster implementation",
        "Potential harm due to different and conflicting practices",
      ],
      correct: "D"
    },
    {
      id: 61011,
      question: "In the EIP Resistors/Facilitators pyramid, what forms the foundation?",
      options: [
        "Vision, Strategic plan, Philosophy of care, Mission",
        "Leadership",
        "Recognition and rewards",
        "Resources and governance",
      ],
      correct: "A"
    },
    {
      id: 61012,
      question: "What is at the top of the EIP Resistors/Facilitators pyramid?",
      options: [
        "Performance expectations",
        "Leadership",
        "Resources and governance",
        "Strategic plan",
      ],
      correct: "B"
    },
    {
      id: 61013,
      question: "What strategy is recommended for stakeholders with high influence but low support?",
      options: [
        "Ignore them",
        "Terminate their involvement",
        "Provide minimal information",
        "Consensus building and detailing benefits for them",
      ],
      correct: "D"
    },
    {
      id: 61014,
      question: "For stakeholders with low support and low influence, which strategy is appropriate?",
      options: [
        "Consensus, build relationships, involve at some level as team member",
        "Heavy involvement in all decisions",
        "Complete exclusion from the process",
        "Confrontation",
      ],
      correct: "A"
    },
    {
      id: 61015,
      question: "What three elements do ALL EIP models include?",
      options: [
        "Funding, staffing, and evaluation",
        "Synthesis of evidence, implementation of evidence, and evaluation of impact on client care",
        "Planning, organizing, and controlling",
        "Research, publication, and presentation",
      ],
      correct: "B"
    },
    {
      id: 61016,
      question: "Which of the following is NOT an example of an EIP model?",
      options: [
        "Iowa Model of Evidence-Based Practice",
        "Ottawa Model of Research Use (OMRU)",
        "SWOT Analysis Model",
        "Rogers\' diffusion of innovations model",
      ],
      correct: "C"
    },
    {
      id: 61017,
      question: "What are the two types of triggers for topic selection in the EIP process?",
      options: [
        "Problem-focused and knowledge-focused triggers",
        "Internal and external triggers",
        "Staff-driven and patient-driven triggers",
        "Budget-based and time-based triggers",
      ],
      correct: "A"
    },
    {
      id: 61018,
      question: "What does PICO stand for?",
      options: [
        "Patient, Intervention, Cost, Outcome",
        "Patient/Population/Problem, Intervention/Treatment, Comparison Intervention, Outcomes",
        "Problem, Investigation, Comparison, Observation",
        "Practice, Implementation, Critique, Observation",
      ],
      correct: "B"
    },
    {
      id: 61019,
      question: "What is the correct sequence of EIP process steps?",
      options: [
        "Form team, select topic, retrieve evidence, rate evidence, synthesize findings",
        "Retrieve evidence, select topic, form team, synthesize findings, rate evidence",
        "Select topic, form team, retrieve evidence, rate evidence, synthesize findings",
        "Rate evidence, retrieve evidence, form team, select topic, synthesize findings",
      ],
      correct: "C"
    },
    {
      id: 61020,
      question: "Which of the following is a barrier to research utilization?",
      options: [
        "Easy access to databases",
        "Difficulty in locating relevant studies",
        "Well-funded research programs",
        "Positive attitudes towards research",
      ],
      correct: "B"
    },
    {
      id: 61021,
      question: "Which is NOT a barrier to research utilization?",
      options: [
        "Communication problems",
        "Cost and time restraints",
        "Collaborative efforts",
        "Negative attitudes towards research",
      ],
      correct: "C"
    },
    {
      id: 61022,
      question: "Which of the following facilitates research utilization?",
      options: [
        "Creating institutional infrastructures",
        "Reducing funding for research",
        "Eliminating continuing education courses",
        "Limiting access to databases",
      ],
      correct: "A"
    },
    {
      id: 61023,
      question: "What characteristic should a literature review have?",
      options: [
        "It should be as lengthy as possible",
        "It should only represent positive findings",
        "It should only include one or two sources",
        "It should be succinct and adequately represent positive and negative findings",
      ],
      correct: "D"
    },
    {
      id: 61024,
      question: "The literature review has relationships with which areas?",
      options: [
        "Research, theory, education, and practice",
        "Only research",
        "Only education",
        "Only practice",
      ],
      correct: "A"
    },
    {
      id: 61025,
      question: "What does a literature review help determine for research design?",
      options: [
        "The need for replication",
        "Funding sources",
        "Staff assignments",
        "Marketing strategies",
      ],
      correct: "A"
    },
    {
      id: 61026,
      question: "What is a concept?",
      options: [
        "A proven fact",
        "A statistical calculation",
        "An image or symbolic representation of an abstract idea",
        "A research finding",
      ],
      correct: "C"
    },
    {
      id: 61027,
      question: "What is a theory?",
      options: [
        "An unproven guess",
        "A single observation",
        "A research method",
        "A set of interrelated concepts, definitions, and propositions that convey a systematic view of phenomena",
      ],
      correct: "D"
    },
    {
      id: 61028,
      question: "What do systematic reviews provide?",
      options: [
        "Subjective opinions",
        "Personal biases",
        "Unverified claims",
        "Best available objective evidence on a topic",
      ],
      correct: "D"
    },
    {
      id: 61029,
      question: "What are refereed journals?",
      options: [
        "Journals that accept any submission without review",
        "Journals that only publish opinions",
        "Peer-reviewed journals with an editorial board of subject experts",
        "Journals without any review process",
      ],
      correct: "C"
    },
    {
      id: 61030,
      question: "In the critical thinking decision path for searching evidence, what is the first step?",
      options: [
        "Ask an answerable question with PICOT elements",
        "Select best source for evidence",
        "Appraise and summarize findings",
        "Consult your librarian",
      ],
      correct: "A"
    },
    {
      id: 61031,
      question: "Which of the following is a synthesized or summarized source for evidence?",
      options: [
        "Personal blogs",
        "Cochrane Systematic Review",
        "Social media posts",
        "Wikipedia articles",
      ],
      correct: "B"
    },
    {
      id: 61032,
      question: "If you cannot find an answer in synthesized sources, what should you do according to the critical thinking decision path?",
      options: [
        "Give up the search",
        "Change the research question entirely",
        "Ignore the problem",
        "Select next source to locate evidence (primary sources)",
      ],
      correct: "D"
    },
    {
      id: 61033,
      question: "If you still cannot find an answer after searching primary sources, what is recommended?",
      options: [
        "Consult your librarian and faculty; you may need to consider a research project",
        "Abandon the project",
        "Make up the answer",
        "Use unreliable sources",
      ],
      correct: "A"
    },
    {
      id: 61034,
      question: "In the Conduct, Dissemination, Use cycle, what follows \"Identify questions\"?",
      options: [
        "Utilize findings in practice",
        "Disseminate knowledge",
        "Improve quality of care",
        "Conduct research",
      ],
      correct: "D"
    },
    {
      id: 61035,
      question: "What follows \"Conduct research\" in the Conduct, Dissemination, Use cycle?",
      options: [
        "Generate new knowledge",
        "Identify questions",
        "Improve quality of care",
        "Utilize findings in practice",
      ],
      correct: "A"
    },
    {
      id: 61036,
      question: "What comes after \"Generate new knowledge\" in the cycle?",
      options: [
        "Identify questions",
        "Disseminate knowledge",
        "Conduct research",
        "Improve quality of care",
      ],
      correct: "B"
    },
    {
      id: 61037,
      question: "What follows \"Disseminate knowledge\" in the Conduct, Dissemination, Use cycle?",
      options: [
        "Generate new knowledge",
        "Conduct research",
        "Utilize findings in practice",
        "Identify questions",
      ],
      correct: "C"
    },
    {
      id: 61038,
      question: "\"Utilize findings in practice\" leads to what in the cycle?",
      options: [
        "Conduct research",
        "Generate new knowledge",
        "Disseminate knowledge",
        "Improve quality of care",
      ],
      correct: "D"
    },
    {
      id: 61039,
      question: "What does conceptually-driven evidence potentially lead to besides integrative reviews?",
      options: [
        "Immediate budget cuts",
        "Formulation of a new theory or generation of new hypotheses",
        "Staff terminations",
        "Facility closures",
      ],
      correct: "B"
    },
    {
      id: 61040,
      question: "The RNABC model is based on whose work?",
      options: [
        "Florence Nightingale",
        "Rogers",
        "Iowa researchers",
        "Stetler",
      ],
      correct: "D"
    },
    {
      id: 61041,
      question: "Which of the following is an EIP facilitator at the organizational level?",
      options: [
        "Lack of leadership",
        "Resources and governance",
        "Absence of strategic plan",
        "No performance expectations",
      ],
      correct: "B"
    },
    {
      id: 61042,
      question: "Performance expectations serve as which of the following in organizations?",
      options: [
        "A barrier only",
        "Neither facilitator nor resistor",
        "An EIP facilitator",
        "A funding source",
      ],
      correct: "C"
    },
    {
      id: 61043,
      question: "What strategy is recommended for stakeholders with low support and high influence?",
      options: [
        "Exclude them from all processes",
        "Avoid all contact",
        "Build relationships and detail benefits for them",
        "Terminate their involvement",
      ],
      correct: "C"
    },
    {
      id: 61044,
      question: "Translating findings to practice is part of which process?",
      options: [
        "Research utilization",
        "Data collection",
        "Sampling",
        "Literature search only",
      ],
      correct: "A"
    },
    {
      id: 61045,
      question: "The literature review helps narrow which aspects of research?",
      options: [
        "Budget and timeline only",
        "Design and methods",
        "Staff and equipment",
        "Location and setting only",
      ],
      correct: "B"
    },
  ],
  "11. Clinical Trial": [
    {
      id: 61100,
      question: "A clinical trial is a designed experimental study to assess which two aspects of a new intervention in humans?",
      options: [
        "Efficacy and safety",
        "Cost and availability",
        "Popularity and marketability",
        "Duration and frequency",
      ],
      correct: "A"
    },
    {
      id: 61101,
      question: "How many phases does a clinical trial consist of?",
      options: [
        "Two phases",
        "Four phases",
        "Six phases",
        "Three phases",
      ],
      correct: "B"
    },
    {
      id: 61102,
      question: "Which phase of clinical trial focuses on checking for safety?",
      options: [
        "Phase II",
        "Phase III",
        "Phase I",
        "Phase IV",
      ],
      correct: "C"
    },
    {
      id: 61103,
      question: "Which phase of clinical trial focuses on checking for efficacy?",
      options: [
        "Phase I",
        "Phase III",
        "Phase IV",
        "Phase II",
      ],
      correct: "D"
    },
    {
      id: 61104,
      question: "What is the sample size for Phase I clinical trials?",
      options: [
        "10-20 healthy volunteers",
        "About 200 patients",
        "More than 1,000 people",
        "Real life patients",
      ],
      correct: "A"
    },
    {
      id: 61105,
      question: "What is the sample size for Phase II clinical trials?",
      options: [
        "10-20 healthy volunteers",
        "About 200 patients",
        "More than 1,000 people",
        "Real life patients",
      ],
      correct: "B"
    },
    {
      id: 61106,
      question: "What is the sample size for Phase III clinical trials?",
      options: [
        "10-20 healthy volunteers",
        "About 200 patients",
        "More than 1,000 people",
        "Real life patients",
      ],
      correct: "C"
    },
    {
      id: 61107,
      question: "What is the sample for Phase IV clinical trials?",
      options: [
        "Healthy volunteers only",
        "About 200 patients",
        "Laboratory animals",
        "Real life patients",
      ],
      correct: "D"
    },
    {
      id: 61108,
      question: "In which phase do most research projects fail due to product not being as effective as anticipated?",
      options: [
        "Phase II",
        "Phase I",
        "Phase III",
        "Phase IV",
      ],
      correct: "A"
    },
    {
      id: 61109,
      question: "Phase III confirms findings in a large patient population and increases the likelihood of detecting what?",
      options: [
        "Manufacturing defects",
        "Rare side effects",
        "Cost savings",
        "Market potential",
      ],
      correct: "B"
    },
    {
      id: 61110,
      question: "In Phase IV, which groups may show adverse reactions?",
      options: [
        "Only young adults",
        "Only elderly patients",
        "Only children",
        "Previously untested groups",
      ],
      correct: "D"
    },
    {
      id: 61111,
      question: "What is efficacy in clinical trials?",
      options: [
        "The capability for a positive change in the practice of medicine and pharmacology",
        "The cost-effectiveness of a treatment",
        "The speed of drug development",
        "The popularity of a medication",
      ],
      correct: "A"
    },
    {
      id: 61112,
      question: "What is toxicity in clinical trials?",
      options: [
        "The therapeutic effect of medication",
        "The critical or lethal reaction to an erroneous dosage of a medication",
        "The manufacturing cost",
        "The shelf life of drugs",
      ],
      correct: "B"
    },
    {
      id: 61113,
      question: "A clinical endpoint refers to what?",
      options: [
        "The end of a study",
        "The budget limit",
        "The final report",
        "Incidence of a symptom or disease that is constituent to one of the targets of trial",
      ],
      correct: "D"
    },
    {
      id: 61114,
      question: "Primary endpoints measure outcomes that will answer what?",
      options: [
        "The most important question in a trial",
        "Secondary concerns only",
        "Budget questions",
        "Marketing strategies",
      ],
      correct: "A"
    },
    {
      id: 61115,
      question: "What is an important characteristic of a clinical trial that requires a control group?",
      options: [
        "Profitability",
        "Speed",
        "Popularity",
        "Comparability",
      ],
      correct: "D"
    },
    {
      id: 61116,
      question: "Without a control group in a clinical trial, what might happen?",
      options: [
        "The study becomes cheaper",
        "The study becomes faster",
        "The importance of the new treatment might be exaggerated",
        "The results become more accurate",
      ],
      correct: "C"
    },
    {
      id: 61117,
      question: "What is the purpose of masking or blinding in clinical trials?",
      options: [
        "To increase costs",
        "To reduce enrollment",
        "To extend study duration",
        "To reduce the risk of bias",
      ],
      correct: "D"
    },
    {
      id: 61118,
      question: "In a double-blind trial, who knows the treatment allocation?",
      options: [
        "The biostatistician only",
        "The patient only",
        "The clinician only",
        "Everyone involved",
      ],
      correct: "A"
    },
    {
      id: 61119,
      question: "In a double-blind trial, who is unaware of the treatment allocation?",
      options: [
        "Only the patients",
        "The patient, clinician, and evaluators",
        "Only the clinicians",
        "Only the evaluators",
      ],
      correct: "B"
    },
    {
      id: 61120,
      question: "What are the three basic clinical trial designs for comparing individuals?",
      options: [
        "Parallel, cross-over, and factorial designs",
        "Single, double, and triple designs",
        "Primary, secondary, and tertiary designs",
        "Simple, moderate, and complex designs",
      ],
      correct: "A"
    },
    {
      id: 61121,
      question: "Parallel designs are considered what type of comparisons?",
      options: [
        "Within-individual comparisons",
        "Time-based comparisons",
        "Cost-based comparisons",
        "Between-individual comparisons",
      ],
      correct: "D"
    },
    {
      id: 61122,
      question: "Cross-over designs are considered what type of comparisons?",
      options: [
        "Within-individual comparisons",
        "Between-individual comparisons",
        "Population-based comparisons",
        "Cost-based comparisons",
      ],
      correct: "A"
    },
    {
      id: 61123,
      question: "Which design is more feasible in clinical research because it provides more accurate comparisons and requires fewer participants?",
      options: [
        "Parallel design",
        "Cross-over design",
        "Factorial design",
        "Open-label design",
      ],
      correct: "B"
    },
    {
      id: 61124,
      question: "In a 2×2 factorial design, how many treatment combinations are possible?",
      options: [
        "Four combinations",
        "Two combinations",
        "Six combinations",
        "Eight combinations",
      ],
      correct: "A"
    },
    {
      id: 61125,
      question: "In the aspirin and beta carotene factorial design example, what did findings indicate?",
      options: [
        "Neither treatment was effective",
        "The combination effect is more effective than either of them alone",
        "Only aspirin was effective",
        "Only beta carotene was effective",
      ],
      correct: "B"
    },
    {
      id: 61126,
      question: "Which of the following are examples of experimental studies?",
      options: [
        "Case-control studies",
        "Epidemiological studies",
        "Cohort studies",
        "Clinical trials, animal research, and laboratory studies",
      ],
      correct: "D"
    },
    {
      id: 61127,
      question: "Which of the following are examples of observational studies?",
      options: [
        "Laboratory experiments",
        "Case-control, cohort, and epidemiological studies",
        "Clinical trials",
        "Animal research",
      ],
      correct: "B"
    },
    {
      id: 61128,
      question: "Which type of studies are more convincing?",
      options: [
        "Observational studies",
        "Survey studies",
        "Experimental studies",
        "Historical studies",
      ],
      correct: "C"
    },
    {
      id: 61129,
      question: "Ecological studies are considered as what type of research?",
      options: [
        "Laboratory research",
        "Animal research",
        "Clinical trials",
        "Epidemiological research",
      ],
      correct: "D"
    },
    {
      id: 61130,
      question: "How many criteria are used to evaluate causation?",
      options: [
        "Five criteria",
        "Three criteria",
        "Four criteria",
        "Six criteria",
      ],
      correct: "A"
    },
    {
      id: 61131,
      question: "Which is a criterion for evaluating causation?",
      options: [
        "The effect must introduce the cause",
        "The cause must introduce the effect",
        "The relationship must be weak",
        "Results should be inconsistent",
      ],
      correct: "B"
    },
    {
      id: 61132,
      question: "What should happen when the causal factor is eliminated?",
      options: [
        "The effect should increase",
        "The effect should reduce",
        "The effect should remain the same",
        "The effect should become unpredictable",
      ],
      correct: "B"
    },
    {
      id: 61133,
      question: "A cohort study is what type of study?",
      options: [
        "Cross-sectional and experimental",
        "Longitudinal (prospective) and observational",
        "Cross-sectional and observational",
        "Longitudinal and experimental",
      ],
      correct: "B"
    },
    {
      id: 61134,
      question: "A case-control study is what type of study?",
      options: [
        "Cross-sectional and experimental",
        "Longitudinal and experimental",
        "Longitudinal (retrospective) and observational",
        "Cross-sectional and observational",
      ],
      correct: "C"
    },
    {
      id: 61135,
      question: "An experiment (clinical trial) is what type of study?",
      options: [
        "Cross-sectional and observational",
        "Cross-sectional and experimental",
        "Longitudinal (retrospective) and observational",
        "Longitudinal (prospective) and experimental",
      ],
      correct: "D"
    },
    {
      id: 61136,
      question: "In a cohort study, what is done first?",
      options: [
        "Define cohort and assess risk factors",
        "Assess risk factors in the past",
        "Define cases and controls",
        "Apply intervention",
      ],
      correct: "A"
    },
    {
      id: 61137,
      question: "In Phase I trials, what may occur?",
      options: [
        "Market approval",
        "Wide distribution",
        "Unexpected side effects",
        "Cost recovery",
      ],
      correct: "C"
    },
    {
      id: 61138,
      question: "Phase I trials use what type of participants?",
      options: [
        "Sick patients only",
        "Elderly patients only",
        "Children only",
        "Healthy volunteers",
      ],
      correct: "D"
    },
    {
      id: 61139,
      question: "Point prevalence is typically measured using which type of study?",
      options: [
        "Longitudinal study",
        "Cross-sectional study",
        "Experimental study",
        "Case-control study",
      ],
      correct: "B"
    },
    {
      id: 61140,
      question: "Which design requires the least number of participants while still providing accurate comparisons?",
      options: [
        "Parallel design",
        "Open-label design",
        "Cross-over design",
        "Factorial design",
      ],
      correct: "C"
    },
    {
      id: 61141,
      question: "In the 2×2 factorial design with aspirin and beta carotene, how many groups are there?",
      options: [
        "Two groups",
        "Three groups",
        "Five groups",
        "Four groups",
      ],
      correct: "D"
    },
  ],
};
